export const lcn = {
    home: '首页',
    manual: `Don’t know how to login? Click <a class="help-popover-text" href={href} target="_blank"> here </a> for a short video.<br>不知如何登录？请点击<a class="help-popover-text" href={href} target="_blank"> 这里 </a>查看操作视频。`,
    manual2: '点击Contact for support弹出客户给KDC公邮提交运维support的界面。包含上传附件',
    login_tip: '如何登录？',
    help_tip: '联系我们',
    support_order: '联系我们',
    problem_description: '描述',
    problem_description_null: '请输入描述！',
    order_file: '附件',
    login_out: '退出',
    i18n_btn: 'Switch English',
    btn_resetPassword: '修改密码',
    btn_resetUserName: '修改用户名',
    btn_confirm: '确认',
    btn_know: '了解',
    btn_cancel: '取消',
    btn_close: '关闭',
    btn_search: '查询',
    btn_search2: '搜索',
    btn_submit: '提交',
    btn_add: '添加',
    btn_add_1: '添加一个',
    msg_success: '成功',
    msg_save_success: '保存成功',
    msg_submit_success: '提交成功',
    msg_error: '失败',
    send_msg_success: '已发送',
    unsend_msg: '未发送',
    msg_delete_sure: '此操作将删除本条数据, 是否继续?',
    sel_msgList_delete_sure: '此操作将删除选中数据，是否继续？',
    msg_submit_sure: '此操作将提交本条数据, 是否继续?',
    login_account: '邮箱',
    login_forget: '忘记密码',
    login_passWorld: '密码',
    login_verification_Code: '验证码',
    login_btn_getCode: '获取验证码',
    login_btn_login: '登录',
    login_msg_success_login: '登录成功',
    login_msg_err_account: '非法账户',
    login_old_passWorld: '旧密码',
    login_new_passWorld: '新密码',
    login_renew_passWorld: '确认新密码',
    login_password_hints:
        '<b>密码规则：</b><br/>1.密码长度不少于12个字符。<br/>2.密码必须包含以下四项中的任意三项：<br/>  - 大写字母; <br/>  - 小写字母; <br/>  - 数字; <br/>  - 英文输入法下的特殊字符(!@#$%^&*());<br/>3.新密码不可与之前14个历史密码相同！',
    login_password_note:'<b>创建强密码小贴士： </b><br>-避免使用简单的序列和个人信息（如名字、电话号码、生日等）;<br>- 不要把您的密码记录在纸上或其他地方；<br>- 使用句子/词组方便记忆（如：I love to eat pizza on Fridays! >>> IItEpoF2024!) ',
    login_btn_back: '返回',
    login_btn_confirm: '确认',
    login_new_userName: '输入新的用户名',
    login_read_terms: '我已阅读并同意毕马威智联平台',
    login_terms: '使用条款',
    person_info_collect: '告知同意书',
    set_session_title: '请配置您登录的过期时长',
    outTimeTips: '长时间无操作时，超时后，您将被自动登出KCC系统',
    dictionary_matterLog_status_being: '解决中',
    dictionary_matterLog_status_open: '待解决',
    dictionary_matterLog_status_close: '已解决',
    newComments:{
        title:'今日有{num}条来自{role}的留言！',
        dlgTitle:'{role}今日最新留言',
        kpmg:'毕马威',
        client:'客户'
    },
    ENTITY_ROOT_DELETE: '不能删除源结点！',
    ENTITY_NODENAME_DUPLICATE: '结点名字不能重复！',
    return_prev_page: '返回上一页',
    return_home_page: '返回首页',
    page_undefined: '你所访问的页面不存在',
    COMMON_DATA_NOT_EXIST: '参数不存在',
    largeSizeFileAlertContent: '为确保最佳下载速度，一次性批量下载的文件大小不可超过{size}。请分批下载。',
    largeSizeFileAlertTitle: '批量下载文件过大！',
    btn_ok: '好的',
    howToUploadPBCFile: '上传PBC演示',
    howToConfigureKCCSite: '配置站点演示',
    howToDownloadPBCFiles: '下载PBC演示',
    Contact: '联系我们',
    configTimeout: '配置超时时间',
    configTimeoutDialogTitle: '请配置您希望的有效登录时长',
    trainingVideo: '培训短视频',
    hour: '小时',
    minute: '分钟',
    second: '秒',
    //menu
    home000: '主页',
    system000: '系统管理员',
    system001: '毕马威用户管理',
    system002: '系统管理员管理',
    system003: '站点管理',
    system004: '主数据管理',
    system005: '访问足迹',
    system006: '安全管理员',
    system007: '首页新闻管理',

    site000: '站点管理',
    site001: '一般设置',
    site002: '客户角色',
    site003: '客户用户',
    site004: '毕马威团队角色',
    site005: '毕马威团队成员',
    site006: '终了并前推至下一年',
    site007: '客户团队文件下载记录',
    site008: '组成部分团队角色',
    site009: '组成部分团队成员',
    site008_settingHome: '组成部分团队<br/>角色',
    site009_settingHome: '组成部分团队<br/>成员',

    client000: '客户主页面',
    client001: '客户应提供的资料管理(PBC)',
    client002: '法定审计报告状态',
    client003: '事项日志',
    client004: '毕马威高管研修',
    client005: '携手共享',
    client005_2: '信息科技整体情况调研',
    client006: '审计函证',
    client007: '集团审计',
    client008: '客户项目管理',
    client008_tips: '（*被授权此角色的客户用户可查看以下所勾选模块的所有内容。）',
    client001_des: '高效收集审计资料,并实时透明化收集进度',
    client002_des: '实时透明化法定审计报告的进度状态',
    client003_des: '及时沟通审计事项，以推动解决和避免日后误解',
    client004_des: '有趣，有料，有故事！客户的成长伙伴。',
    client005_des: '便捷安全地分享文件以及在线信息技术问卷调查',
    client006_des: '函证授权并实时掌握函证进度',
    client007_des: '与您的毕马威组成部分团队进行在线协作',
    client008_des: '汇总展示账单及电子发票，增值税信息，合同以及费用协议信息',
    ROLE_client001: 'A-客户应提供的资料管理(PBC)',
    ROLE_client002: 'F-法定审计报告状态',
    ROLE_client003: 'G-事项日志',
    ROLE_client004: 'E-毕马威高管研修',
    ROLE_client005: 'B-携手共享',
    ROLE_client006: 'C-审计函证(*勾选后可查看所有函证）',
    ROLE_client007: 'H-集团审计',
    ROLE_client008: 'D-客户项目管理',
    courseList: '课程列表',
    csConsult: '洞察咨讯',
    myCourse: '我的',
    courseDetail: '课程详情',
    myCourses: '我的浏览',
    myFafourite: '我的收藏',

    DIRECT_DATA_EXTRACTED: '直接数据导出',
    MANAGEMENT_REPORTS: '现有管理层报告',
    SUPPORTING_DOCUMENT: '其他支持性文件',
    ANALYSIS: '为审计执行的具体分析',
    NOT_APPLICABLE_CLIENT: '不适用(客户操作)',
    NOT_APPLICABLE_KPMG: '不适用(毕马威操作)',
    CHANGE_SOURCETYPE_NO_APPLICATION_WARNING: '调整为“不适用”后，将不可以继续上传文件。确认此操作吗？',
    groupReportingTip: '为遵循数据跨境政策要求，该版块开启后将不可再手动关闭；如需关闭请联系KCC团队！',

    newsMgt:{
        kccNews:'KCC新鲜事',
        usefulDocument:'与客户沟通使用KCC',
        materials:'KCC培训材料',
        seq:'#',
        newsTitle:'标题',
        newsDesc:'描述',
        linkText:'链接文本',
        linkUrl:'链接URL',
        newsOrder:'显示顺序',
        newsImage:'配图',
        docCategory:'类别',
        docCatalog:'子类别',
        docName:'文档名称',
        hyperlink:'文档链接',
        docOrder:'显示顺序',
        materialTitle:'标题',
        materialCategory:'类别',
        materialOrder:'显示顺序',
        materialImage:'配图',
        title1:"KCC新鲜事",
        title2:'开启你的KCC之旅吧！',
        title3:'与客户沟通使用KCC',
        title4:'“码”上了解KCC',
        videoIntroduction:'KCC简介视频',
        videoList:{
            introduction:'KCC简介视频(2024新版)',
            introductionClient:'KCC简介视频',
            newlyLaunched:"KCC全新上线“审计函证”模块！",
            cn:'普通话',
            en:'英文',
            yueyu:'粤语'
        },
        learningCourse:' KCC e-learning课程',
        overview:'KCC“码”上了解',
        scanTips:'将此二维码分享给你的客户',
        serviceDesk:'KCC Site Set-up Services',
        contactTeam:'联系KCC团队',
        publish:'发布',
        publishTitle:'确认发布吗？',
        publishTips:'更新后的内容将自动发布至所有毕马威用户界面并立即生效',
        status:{
            0:'草稿',
            1:'已发布'
        }
    },

    STATUS_DAYS_OVERDUE: {
        _1: '已逾期',
        _2: '天以内',
        _3: '已逾期'
    }, // 'days overdue',
    STATUS_DAY_UNTILDUE: {
        _1: '',
        _2: '天内到期',
        _3: '即将到期',
        _4: '即将到期',
        _5: '天后到期'
    }, // 'days until due',

    ROUTRE_META_1: '管理PBC清单',



    COMMON_001: '请求参数无效',
    COMMON_004: '您没有当前操作权限!',
    COMMON_005: '未设置白名单',
    COMMON_006: '该用户邮箱尚未加入白名单内',

    CLIENT_USER_002: '用户名或密码错误',
    CLIENT_USER_003: '该用户帐号已存在于此KCC站点：',
    CLIENT_USER_004: '此用户账号（邮箱）不存在或未注册！',
    CLIENT_USER_006: '验证码不正确',
    CLIENT_USER_007: '旧密码不正确',
    CLIENT_USER_008: '新密码不能和旧密码一样',
    CLIENT_USER_010:
        '<b>密码规则：</b><br/>1.密码长度不少于12个字符。<br/>2.密码必须包含以下四项中的任意三项：<br/>  - 大写字母; <br/>  - 小写字母; <br/>  - 数字; <br/>  - 特殊字符(!@#$%^&*())<br/>3.新密码不可与之前14个历史密码相同！',
    CLIENT_USER_011: '新密码不可与之前14个历史密码相同!',
    CLIENT_USER_012: '一天只能修改一次密码',
    CLIENT_USER_013: '账号已经被锁，请30分钟后再试',
    CLIENT_USER_014:
        '此重置密码链接已失效，请点击“忘记密码”重新获取！',
    CLIENT_USER_015: `该客户用户在“审计函证”版块已关联审计函证，如确认删除该客户用户，请先更新对应订单编号的Client confirmation responsible person list并重新上传，再进行删除KCC站点客户用户的操作。<br />* 具体订单编号可在审计函证模块中筛选“被审计单位负责人”后查看。`,
    USER_IP_NOTAVALIABLE: `<span>您登录KCC的IP地址[{ip}]不在白名单内！请联系您的毕马威项目经理获取帮助！</span>`,
    USER_IP_NOTAVALIABLE_2: `<span>您登录KCC的IP地址不在白名单内！请联系您的毕马威项目经理获取帮助！</span>`,
    WHITELIST_DELETE_ERROR: '白名单已绑定客户用户，不可删除!',

    verification_code_send_success4Email:'<div>成功！验证码已发送至您的邮箱，有效时间为30分钟。<div>',
    verification_code_send_success4SMS:'<div>成功！验证码已发送至您的手机，有效时间为30分钟。<div>',

    SYS_USER_001: '用户账号已经存在',
    SYS_USER_002: '该用户已经添加过该角色',
    SYS_USER_003: '请求失败',
    SYS_USER_004: '不能删除',
    SYS_USER_005: '最后一个系统管理员不能删除',
    SYS_USER_006: 'Site管理员不能被删除',
    SYS_USER_007: 'Kpmg用户不存在',
    SYS_USER_008: '用户不存在',
    SYS_USER_009: '只允许添加大陆人员为管理员',
    SYS_USER_010: '该用户是system admin用户，不能成为安全管理员',
    SYS_USER_011: '导入excel为空',

    SITE_001: 'Site名称已经存在',
    SITE_002: 'Site中已经存在该用户，不能重复添加',
    SITE_003: '最后一个Site管理员不能被删除',
    SITE_005: 'EngagementMasterCode已经存在',
    SITE_006: '注意EngagementMasterCode已经存在多个',
    SITE_004: 'Site名称必须是唯一的，并且不能包含以下任何字符： /：，*？ <> |',
    SITE_007: '该code已经关联过kcc站点，不可再关联至其他KCC站点！',
    SITE_008: '该code已经被roll-forward过，不可再关联至其他KCC站点！',
    INSIGHT_001: 'Insight名称已经存在',
    INSIGHT_002: 'Insight项个数不能超过14个',
    MEMBER_ADD_GROUP_SECTION: '添加失败！如需添加集团审计团队成员，请在“毕马威团队成员“卡片中操作。',
    COMPONENT_ADD_MEMBER_SECTION: '添加失败！如需添加组成部分团队成员，请在“组成部分团队成员“卡片中操作。',

    ROLE_001: '该角色名称已存在',
    ROLE_002: '角色名称不能为空或空格。',
    ROLE_003: `<span>无法更新，安全管理员或者系统管理员【{security_admin}】不能设置为站点管理员</span>`,

    ENTITY_001: '实体名称已经存在',
    ENTITY_002: '实体名称不能包含以下任何字符： /：*？ <> |',
    ENTITY_003: '实体名称不可为空。',

    FILE_UPLOAD_001: '不能上传',
    FILE_UPLOAD_002: '上传的目录不能为空',
    FILE_UPLOAD_003: '该文件类型不能上传',
    FILE_UPLOAD_004: '文件名不能有空格',
    FILE_UPLOAD_005: '没有选择任何文件进行上传',
    FILE_LIST_TITLE: '文件列表',
    FILE_TOTAL_SIZE_HINT: '存在未知文件大小, 当前总大小: > {size}',
    FILE_SELECTED_SIZE_HINT: '当前总大小: {size}',
    FILE_NONE_DOWNLOAD: '选择没有下载记录的文件',
    FILE_SELECT_ALL: '全选',
    FILE_SELECT_INVERSE: '反选',
    FILE_SELF_NONE_DOWNLOAD: '选择我从未下载过的文件',
    FILE_OVER_SIZE_ALERT: '为保障更好的下载速度，请减少批量下载的文件数量至总大小<{size}。',
    FILE_DOWNLOAD_001: '不能下载',
    FILE_DOWNLOAD_002: '下载的文件目录不能为空',
    FILE_DOWNLOAD_003: '下载的文件不存在',
    FILE_DOWNLOAD_004: 'Token无效',

    FILE_DELETE_001: '不能删除',
    FILE_DELETE_002: '文件名不能为空',
    FILE_DELETE_003: '文件目录不能为空',
    PBC_LIST_ADD_ERR: '实体或会计科目为空',

    PBC_GROUP_ADD_001: 'PBC名称已经存在',
    PBC_GROUP_ADD_002: '保存失败！已创建好的PBC清单中已存在“年终/中期&客户实体&期末日期&会计科目&数据要素”均相同的PBC条目，请勿重复创建！',

    PBC_GROUP_DELETE_001: '该PBC清单中已有客户上传了文件，无法删除！',

    PBC_GROUP_UPDATE_001: '修改的记录里有上传文件，无法修改',
    PBC_GROUP_QUERY_001: '资料清单数据不存在',
    COPY_PBC_GROUP_001: '年末审计数据无法复制',
    CHANGE_PBC_STATUS_001: '资料清单状态不是已上传，无法修改',

    FILE_IMPORT_001: '需要上传的文件不存在',
    FILE_IMPORT_002: '文件不是Excel2007以上的文件',
    FILE_IMPORT_003: '导入失败!',
    FILE_IMPORT_004: '导入模板中，“已识别的相关数据要素”部分单元格内容过多！不可超过250个汉字 （或250个英文字母）！',

    MESSAGE_ERROR01: '请输入留言内容',

    MASTER_DATA_ADD_001: '主数据添加失败',
    MASTER_DATA_ADD_002: '事项已经存在',
    MASTER_DATA_INVALID_001: '主数据名称不能包含以下字符:  / : , * ? < > |',

    file_upload_failed: '上传失败！',
    file_upload_success: '上传成功！',
    file_upload_success2: `<span>提交成功！<br>毕马威KCC Help Desk已收到您的信息，将尽快反馈您！反馈信息将发送至您的注册邮箱[{email}]. </span>`,
    file_import_success: '导入成功!',
    record_is_exist: '该PBC清单中存在”会计科目“”数据要素“均相同的PBC条目，请勿重复创建！',
    record_is_exist1: '该PBC清单中存在”会计科目“”数据要素“均相同的PBC条目，请勿重复创建！',
    account_upload_info: '重复的定制化PBC条目将会被忽略不建（“会计科目”以及“ 已识别的相关数据要素”均相同）',
    account_check_error: '请输入账号!',
    deactivated_error: '您的KCC账号已被停用(可能由于您长时间未登录使用)！请联系您的毕马威团队项目经理获取帮助。',
    forget_pass_world: '重置密码邮件已发送，请查收邮件！',
    client_user_dele_warning: '该用户已启用不能删除！',
    clientRoles_delete_sure: '角色删除后可能会影响部分客户用户对KCC站点内容的访问权限。确定删除吗？',
    kpRoles_delete_sure: '角色删除后可能会影响部分毕马威团队成员对KCC站点内容的访问权限。确定删除吗？',
    client_user_add_warning: `<span style="color:#fd349c;">数据跨境政策重要提示！<br><ul><li>如果此KCC站点是毕马威华振的大陆项目站点，请确认被邀请的客户用户是客户的员工，且位于中国大陆。</li><li>如果此KCC站点毕马威香港项目的站点，则不可以添加中国大陆的客户用户！</li></ul><br></span>`,
    client_user_add_warning2:
        '给客户发送KCC初始密码前，请先分配客户的访问权限，包括“访问权限类别”及“授权实体或角色”',
    full_screen: '全屏',
    full_no_screen: '取消全屏',
    comment_reSet: '取消',
    comment_send: '发送',
    import_file_type_error: '导入模板只能是excel格式!',
    import_img_type_error:'请上传图片',
    import_file_size_error: '导入模板不能超过5MB!',
    import_tpl_size_100k_error: '导入模板不能超过100KB!',
    import_file_size_100k_error:'图片大小不能超过100KB',
    NODE_DELETE_ERROR: '该实体无法删除，因为它已经关联角色或事项日志、法定帐户状态模块或资料清单',
    MENU_CHECKED_ERROR: '关闭版块失败！该版块已关联了客户角色，请在客户角色配置中解除关联关系后再次尝试！',

    ILLEGAL_USER_INPUT_01: '不可输入以下特殊字符: \\ / : * ? < > | ” “ " , ，',
    ILLEGAL_USER_INPUT_02: '非法的用户输入包含 \\ / : * ? < > | ” “ " ',
    ILLEGAL_USER_INPUT_03: '密码不符合规则！请查看左侧相关要求',
    ILLEGAL_USER_INPUT_04: '不可输入以下特殊字符:\\ / : * ? < > | ” “ " , ，',
    ENTER_SEARCH_CONTENT: '请输入搜索内容',
    CLIENT_HOME_CONTACT: '客户联系人',
    CLIENT_HOME_KPCONTACT: '毕马威联系人',
    COMMON_INTERIM: '中期',
    COMMON_FINAL: '年终',
    FORM_VALIDATE_REQUIRED: '必填！',
    FORM_VALIDATE_URL: '不合法的链接！',
    FORM_VALIDATE_LOGIN_MAX: '密码最小长度为12个字符！',
    FORM_VALIDATE_LOGIN_MAX8: '密码最小长度为8个字符！',
    FORM_VALIDATE_PASSWORLD: '请输入密码！',
    FORM_VALIDATE_ACCOUNT: '请输入账号！',
    FORM_VALIDATE_OLD_PASSWORD: '请输入旧密码！',
    FORM_VALIDATE_NEW_PASSWORD: '请输入新密码！',
    FORM_VALIDATE_NEW_PASSWORD_INCONSISTEN: '两次输入密码不一致！',
    FORM_VALIDATE_RENEW_PASSWORD: '请确认新密码',
    FORM_VALIDATE_DUPLICATE_KEY: '不能有重复的键',
    FOOTER_LEGAL: '<a style="color: blue;" href="https://home.kpmg/cn/zh/home/misc/legal.html" target="_blank">法律</a>',
    FOOTER_PRIVACY: '<a style="color: blue;" href="https://home.kpmg/cn/zh/home/misc/privacy.html" target="_blank">隐私</a>',
    FOOTER_DES:
        ' 毕马威科技服务(香港)有限公司 — 香港特别行政区有限责任公司，是与毕马威国际有限公司(英国私营担保有限公司)相关联的独立成员所全球组织中的成员。<br />版权所有，不得转载。毕马威的名称和标识均为毕马威全球组织中的独立成员所经许可后使用的商标。 ',
    LOGIN_PAGE_DES:
        'Hints:Password should contain any three of the following four qualities:Uppercase Characters,Lowercase Characters,Alphanumeric Characters,Special Characters <!@#$%^&*()> with 8 characters at least.提示：密码应包含以下四种品质中的任意三种：大写字母，小写字母，字母数字字符，特殊字符<！@＃$ %% ^＆*（）>至少具有8个字符',
    LOGIN_PAGE_CHANGE_TITLE: '修改密码',
    btn_save: '保存',
    COMMON_EXPORT: '导出',
    COMMON_ADD_ITEM: '添加项目',
    MATTER_ADD_ITEM: '添加事项',
    COMMON_UPDATE_START: '更新起始时间',
    COMMON_UPDATE_END: '更新结束时间',

    TABLE_HEADER_ENTITIES: '实体',
    TABLE_HEADER_FISTDRAFTRECEIVED: '接收客户提供的首份初稿',
    TABLE_HEADER_TARGET_OF1ST_DRAFT: '预计日期',
    TABLE_HEADER_UNDERREVIEWD: '毕马威内部审核中',
    TABLE_HEADER_AWAITINGADDITION: '等待客户提供更多信息',
    TABLE_HEADER_peddingFinalApproval: '等待客户确认终稿',
    TABLE_HEADER_finalisation: '毕马威生成终稿（加总检验、中英文报告对照核对、装订成册',
    TABLE_HEADER_clientSignOff: '客户签字确认',
    TABLE_HEADER_kpmgSignOff: '毕马威签字确认',
    TABLE_HEADER_TARGET_OF_SIGN_OFF: '预计签署日期',
    TABLE_HEADER_STATUS: '状态',
    TABLE_HEADER_DUEDAY: '集团小组设置的截止日期',
    TABLE_HEADER_CONFIRM_DUEDAY: '组成部分确认的截止日期',
    TABLE_HEADER_KPUSER: '负责人',
    TABLE_HEADER_MODIFY_RECORD: '状态变更记录',
    MODIFY_HEADER_BEFORE: '修改前状态',
    MODIFY_HEADER_AFTER: '修改后状态',
    SET_DUEDAYALARM: '定制自动提醒频率',
    COMMON_DAY: '天',
    TIME_OPTION: '选项',
    COMMON_PERIOD: '{msg}预警',
    DUEDAY_WARNING: '如果未配置负责人，则不会触发邮件提醒。',
    SET_DUEDAYALARM_MESSAGE: '修改失败，请退出界面重试',
    SET_DUEDAYALARM_MESSAGE2: '周期不能为空或零',
    SET_DUEDAYALARM_MESSAGE3: '只能输入整数',
    TABLE_HEADER_DATE: '实际日期',

    TABLE_HEADER_title: '标题',
    TABLE_HEADER_title2: '职位',
    TABLE_HEADER_matter: '事项',
    TABLE_HEADER_entityList: '客户 / 实体 / 子实体',
    TABLE_HEADER_category: '财务报表科目',
    TABLE_HEADER_category_placeholder: '财务报表科目',
    TABLE_HEADER_Issues: '审计事项 / 问题状态',
    TABLE_HEADER_Deficiency: '事项 / 问题类型',
    TABLE_HEADER_Adjustment: '可能的审计调整',
    TABLE_HEADER_Difference: '审计差异',
    TABLE_HEADER_Description: '事项 / 问题描述',
    TABLE_HEADER_Description_placeholder: '事项 / 问题描述',
    TABLE_HEAD_EntityList: '客户实体 / 子实体',
    TABLE_HEAD_EntityList_group: '组成部分',
    select_category: '创建文件夹类别',
    select_entity: '选择适用的客户实体',
    select_entity_group: '选择适用的组成部分',
    TABLE_HEAD_EntityList2: '组成部分',
    TABLE_HEAD_Category: '文件夹类别',
    custom_folder_category: '自定义文件夹类别',
    TABLE_HEADER_EXCHANGE_STATUS: '进度状态',
    ECHANGE_STATUS: {
        _1: '待提交',
        _2: '已提交给集团项目组',
        _3: '需修订',
        _4: '集团项目组已审阅'
    },
    TABLE_HEAD_COMMENTS: '留言',
    PAGE_EXCHANGE_TAB1: '毕马威&客户文件交换',
    PAGE_EXCHANGE_TAB1_for_clientrole: '携手共享',
    PAGE_EXCHANGE_TAB2: '集团审计-报告收集',
    PAGE_EXCHANGE_TAB3: '集团审计-共享文件',
    PAGE_EXCHANGE_TAB4: '信息科技整体情况调研',
    EXCHANGE_BATCH_STATUS: '修改状态',
    EXCHANGE_BATCH_DEADLINE: '修改截止日期',
    EXCHANGE_BATCH_KPUSER: '修改负责人',
    ENTITY_CATEGORY_001: '该记录已存在，请勿重复添加!',
    ENTER_CATEGORY_LIST: '请选择类别',
    ENTER_ENTITY: '请输入并选择实体/子实体',
    entity: '实体',
    subEntity: '子实体',
    demo_site: '示例站点',

    FORM_LABEL_matterType: '事项 / 问题类型',
    FORM_LABEL_Organization: '客户 / 实体 / 子实体',
    FORM_LABEL_kpmgOwner: '毕马威负责人',
    FORM_LABEL_clientOwner: '客户负责人',
    FORM_LABEL_status: '状态',
    FORM_LABEL_priority: '优先级',
    FORM_LABEL_relatedIssue: '有关问题',
    FORM_LABEL_description: '描述',
    FORM_LABEL_attachmentList: '文件列表',
    FORM_LABEL_attachmentList_short: '文件列表',
    PAGE_MATTERLOG_UPLOAD_TIP:
        '允许上传xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg文件，且每个文件不超过2G',
    PAGE_MATTERLOG_UPLOAD_TIP1: '需要手动点击保存按钮以关联该事项日志与附件',
    PAGE_MATTERLOG_COMMENTS: '留言',
    PAGE_MATTERLOG_REPLY: '回复',
    PAGE_MATTERLOG_DUDATE: '毕马威建议截止日期',
    KPMG_Due_Date: '毕马威建议截止日期',
    PAGE_MATTERLOG_DUDATE_BY_CLIENT: '客户确认截止日期',
    Client_Confirmed_Due_Date: '客户确认截止日期',
    PAGE_MATTERLOG_BRIEFCOMMENT: '最新留言',
    PAGE_MATTERLOG_UPLOAD_LIMIT: '最多上传3个文件',
    PAGE_MATTERLOG_SOURCE_OF_INFORMATION: '信息来源',
    PAGE_MATTERLOG_UPLOAD_TYPE: '允许上传 xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg 格式文件',
    PAGE_MATTERLOG_UPLOAD_SIZE: '文件大小不能超过2G!',

    PAGE_PBC_CHANGETO: '修改为',
    PAGE_PBC_COMMENTS: '备注',
    COMMON_SELECT: '请选择',
    COMMON_INPUT_AND_SELECT: '输入并选择',
    TABLE_HEADER_topicName: '会计科目',
    TABLE_HEADER_sub_topicName: '子会计科目',
    TABLE_HEADER_periodEndDate: '期末日期',
    TABLE_HEADER_Message: '留言',
    TABLE_HEADER_clientUserName: '客户方负责人',
    client_user_email_keyword: '客户用户邮箱(关键字)',
    TABLE_HEADER_kpmgUserName: '毕马威负责人',
    TABLE_HEADER_uploadedBy: '最近上传人',
    TABLE_HEADER_detailedInfoReq: '所需详细资料',
    TABLE_HEADER_uploadedDate: '最近上传时间',
    TABLE_HEADER_fileNameList: '文件列表',
    TABLE_HEADER_Action: '操作',
    DASHBOARD_TAB_TIP: '定制化item在Account及sub-account里均显示且内容相同',
    DASHBOARD_TOTAL: '总计',
    COMMON_CHANGESTATUS: '更新状态',
    COMMON_CHANGESTATUS_COMMENTS: '驳回备注',
    COMMON_DOWNLOAD: '下载',
    BATCH_DOWNLOAD: '批量下载',
    COMMON_CHOOSE: '筛选',
    COMMON_ING: '中',
    COMMON_UPLOAD_START: '最近上传起始时间',
    COMMON_UPLOAD_END: '最近上传结束时间',
    COMMON_UPLOAD_DATE: '最近上传',
    COMMON_DUE_START: '毕马威建议截止起始时间',
    COMMON_DUE_END: '毕马威建议截止结束时间',
    COMMON_PERIODEND_START: '期末日期起始时间',
    COMMON_PERIODEND_END: '期末日期结束时间',
    COMMON_SET_STATUS: '批量更新状态',
    COMMON_COPY_INTERIM: '延用中期的PBC清单',
    COMMON_PBC_LIST: '设置PBC资料清单',
    pbc_change_tips: '更新尚未保存！确认继续此操作？',
    COMMON_PBC_TITLE_LIST: 'A- PBC清单',
    COMMON_CLEAR_BTN: '重置',
    COMMON_CATEGORY_LIST: '毕马威&客户文件交换',
    PAGE_PBC_LIST_DETAILED: '配置PBC清单',
    BASE_INFO: '基本信息',
    step_1: '选择客户实体',
    step_2: '选择会计科目/条目',
    PAGE_PBC_LIST_NAME: '清单名称',
    PAGE_PBC_LIST_TOPIC: '会计科目',
    standardAccounts: '标准会计科目/条目',
    PAGE_PBC_LIST_TOPIC_CUS: '定制会计科目/条目',
    PAGE_PBC_LIST_SELECT_TOPIC: 'A- PBC清单中的具体条目',
    PAGE_PBC_LIST_EDITCHILD: '批量编辑子节点',
    PAGE_PBC_LIST_EDITCHILDDATE: '批量编辑日期',
    PAFE_PBC_LIST_DESC: '已识别的相关数据要素',
    PAGE_PBC_LIST_CEHCK_DUEDATE: '当勾选的时候截止日期不能为空',
    PAGE_PBC_ADD_TOP: '新增定制化PBC需求条目',
    PAGE_PBC_ACCOUNT_DES: '需求描述',
    IMPORT_ACCOUNT_BTN: '导入定制化PBC条目',
    batchImport: '批量导入',
    COMMON_ADD: '新增条目',
    COMMON_UPLOAD: '上传',
    PAGE_PBC_UPLOAD_TIP:
        '最多可上传{size}份文件；每份文件不可超过1GB！支持以下文件类型：xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    PAGE_PBC_UPLOAD_TIP_1:
        '每份文件不可超过1GB！支持以下文件类型：xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    PAGE_PBC_UPLOAD_text1: '拖至此处，或',
    PAGE_PBC_UPLOAD_text2: '点击选择',
    PAGE_PBC_UPLOAD_SIZE: '文件大小不能超过1G',
    PAGE_PBC_UPLOAD_LIMIT: '最多上传{size}个文件',
    PAGE_PBC_UPLOAD_LIMIT_80: '最多上传包含历史版本在内80个文件',
    PAGE_PBC_TOPIC_REPEAT: '会计科目名称重复',
    PAGE_LOGIN_ERROR:
        'You are not yet authorised of any KCC site. Please contact your engagement manager (KCC Lite site manager) for authorisation and try again.\n您目前还没有任何被授权的KCC站点。请联系你的项目经理（KCC Lite站点管理员）进行授权后再尝试。',
    FILE_LIST_EMPTY_ALERT: '未查找到文件或者您没有权限下载！',

    FORM_LABEL_siteName: '站点名称',
    FORM_LABEL_clientName: '客户名称',
    siteTips1:'当Engagement Code关闭时(IBS 中状态为‘Closed’)，KCC站点中所有已上传的文件均会被自动删除！',
    siteTips2:'Roll forward此KCC站点至本期审计项目，以重复使用其已搭建好的站点框架！',
    siteTips3:'将KCC站点所关联的Opportunity code 或 Business development code更新为Engagement code！',
    SET_WHITE_LIST: '设置邮箱白名单',
    SET_IP_WHITE_LIST: '设置IP白名单',
    SET_IP_WHITE_LIST_TITLE: '设置IP白名单',
    SET_WHITE_LIST_FIRST: '请先设置邮箱白名单',
    WHITE_LIST: '白名单',
    IP_WHITE_LIST: 'Ip白名单',
    WHITE_LIST_DELE_WARNING: '确定要删除该白名单吗？',
    ENTER_WHITE_LIST_PLACEOLDER: '请输入客户的工作邮箱后缀 “@client.com”。',
    ENTER_IP_WHITE_LIST_PLACEHOLDER: '如“127.0.0.1,127.0.0.2”',
    WHITE_LIST_TIP: '白名单是为了保障所有授权的客户用户均使用工作邮箱进行KCC帐号注册。',
    IP_WHITE_LIST_TIP: '默认不做限制；可基于客户方IT风险控制要求，设置允许客户端用户登录KCC的IP地址白名单！',
    ENTER_WHITE_LIST: '请输入白名单！',
    ENTER_IP_WHITE_LIST: '请输入ip白名单',
    EMAIL_IS_EXIST: '邮箱已存在，请重新输入',
    IP_IS_EXIST: 'ip已存在，请重新输入',
    OPERATE_ING_WARNING: '正在进行其他操作,请先完成其他操作',
    FORM_LABEL_URL: '地址链接',
    FORM_LABEL_Image: '图片',
    PAGE_GENERAL_UPLOAD_SIZE: '上传文件不能超过1M!',
    PAGE_GENERAL_UPLOAD_TYPE: '上传文件必须是 jpeg/gif/png 格式!',

    TREE_BTN_ADD_ENTITY: '添加实体',
    TREE_BTN_ADD_SUB: '添加子实体',
    COMMON_DELETE: '删除',
    TREE_BTN_MOVE_UP: '上移',
    TREE_BTN_MOVE_DOWN: '下移',
    COMMON_NAME: '名字',
    TREE_BTN_ADD_ERROR: '请先选择实体再增加它的子节点!',
    TREE_BTN_MOVE_UP_ERROR: '已经排在第一个！',
    TREE_BTN_MOVE_DOWN_ERROR: '已经排在最后一个！',

    PAGE_GENERAL: '一般设置',
    PAGE_GENERAL_TITLE1: '管理客户组织结构',
    PAGE_GENERAL_TITLE2: '管理各功能版块',
    PAGE_GENERAL_TEST: '测试',
    COMMON_EDIT: '编辑',
    FORM_LABEL_siteAdmin: '站点管理员',
    FORM_LABEL_siteAdminCustom: '现有站点管理员',
    ADD_FORM_LABEL_siteAdmin: '添加更多管理员',
    searchPlaceholder: '搜索员工名',

    PAGE_CLIENTROLES_TITLE: '客户角色',
    PAGE_CLIENTROLES_ADD: '新增角色',
    TABLE_HEADER_roleName: '角色名称',
    TABLE_HEADER_modifyDate: '修改日期',
    PAGE_CLIENTROLES_PERMISSION: '角色权限',
    CLIENTROLE_ADD_STEP1: '该角色可以访问哪些实体？',
    CLIENTROLE_ADD_STEP2: '该角色可以访问哪些功能模块？',
    CLIENTROLE_ADD_STEP3: '该角色可以访问哪些PBC清单，共享文件夹以及客户项目管理内容？',
    CLIENTROLE_ADD_STEP4: '该角色可以访问各PBC清单中的哪些条目(模块A)？',

    COMMON_ENTITY: '实体',
    COMMON_TILES: '版块',

    PAGE_CLIENTUSER_TITLE: '客户用户',
    COMMON_USER_NAME: '用户名',
    PAGE_CLIENTUSER_EMAIL: '发送提醒邮件',
    PAGE_CLIENTUSER_EMAIL_PBC: '提醒客户提交PBC',
    PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB0: '提醒客户下载文件',
    PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB1: '提醒组成部分团队提交资料',
    PAGE_CLIENTUSER_PAD_EMAIL: '给客户发送初始密码',
    sendTime: '发送日期',
    PAGE_CLIENTUSER_ADD: '添加新用户',
    ADD_CLIENT_USER:'添加新客户用户',
    EDIT_CLIENT_USER:'编辑客户用户',
    client_identity_type:{
        '1':'中国大陆客户员工',
        '2':'港澳客户员工',
        '3':'海外客户员工'  
      },
    PAGE_CLIENTUSER_EDIT: '编辑用户',
    COMMON_DOWNLOAD_TEMP: '下载导入模板',
    COMMON_IMPORT: '导入',
    COMMON_USER_ACCOUNT: '用户账号',
    USER_WORKING_EMAIL: '客户工作邮箱',
    email_warn: '请勿使用客户个人邮箱，以避免数据泄露风险！',
    TABLE_HEADER_Roles: '角色',
    TABLE_HEADER_Roles_des: '*客户用户默认即可查看“审计函证”版块中自己所负责的询证函(如有)。如需访问其他功能版块请相应分配客户角色以授权。',
    CLIENT_USERS_TIPS:
        '毕马威项目组应定期检查客户用户帐号的效性。如客户（短时间内）不再需要访问KCC或邮箱已失效，请停用或删除该客户用户帐号!',
    cilentExportUserList: '导出用户清单',
    TABLE_HEADER_createTime: '创建时间',
    TABLE_HEADER_ifContact: '显示为客户方联系人',
    TABLE_HEADER_KPifContact: '显示为毕马威联系人',
    TABLE_HEADER_IfComponentMember: '组成部分人员',
    TABLE_HEADER_CLIENT_IDENTITY: '客户身份',
    TABLE_HEADER_Active: '启用',
    Activated: '帐号已启用？',
    account_yes: '已启用',
    account_no: '已停用',
    Last_Login: '最近登录时间',
    Last_Active_Time: '最近活跃日期',
    Date_Type: '活跃类型',
    Deactivate_Setting: '帐号自动停用期限(长时间不活跃)',
    deactivate_setting: {
        _3: '3个月',
        _4: '4个月',
        _5: '5个月',
        _6: '6个月'
    },
    TABLE_HEADER_SuperFlag: '查看所有审计函证',
    TABLE_HEADER_EMAIL_STATUS: '邮件状态',
    EMAIL_SEND_STATUS: '发送状态',
    BACKUP_MAILBOX: '备用邮箱',
    BACKUP_MAILBOX_DESC: '请谨慎使用客户的个人邮箱，以避免数据泄露风险！',
    BACKUP_MAILBOX_WARNING: '此备用邮箱用于解决客户注册邮箱收不到KCC初始密码、登录验证码或重置密码链接的问题。请及时删除！',

    PAGE_KPMG_TEAM_TITLE: '毕马威团队成员',
    PAGE_KPMG_TEAM_OWNER: '项目合伙人',
    PAGE_KPMG_TEAM_MANGER: '项目经理',
    PAGE_KPMG_TEAM_ADMIN: '站点管理员',
    TABLE_HEADER_EMAIL_StaffNo: '工号',
    TABLE_HEADER_EMAIL_ProfitCenter: '利润中心',
    TABLE_HEADER_EMAIL_StaffName: '员工名',
    TABLE_HEADER_EMAIL_Position: '职位',
    TABLE_HEADER_EMAIL_Email: '邮箱',
    TABLE_HEADER_CLIENTUSER: '客户用户',
    PAGE_KPMG_ROLE_TITLE: '毕马威用户角色',
    PAGE_KPMG_ROLE_TITLE_group: '毕马威团队角色',

    // KPMG User Management
    KPMG_USER_MANAGEMENT_TITLE: '毕马威用户管理',
    KPMG_USER_MANAGEMENT_PLACE_HOLDER: '工号,员工名,利润中心',

    //System Admin Management
    KPMG_SYSTEM_ADMIN_MANAGEMENT_TITLE: '系统管理员管理',
    KPMG_SYSTEM_ADMIN_MANAGEMENT_PLACE_HOLDER: '工号,员工名',

    //Site Management

    SITE_MANAGEMENT: '站点管理',
    SITE_CODE_PLACEHOLDER: '站点编码',
    SITE_PLACE_HOLDER: '站点名称,管理员,修改人',
    SITE_START_DATE: '起始时间',
    SITE_TO: '到',
    SITE_END_DATE: '结束时间',
    SITE_CLOSE_DATE: 'Code关闭时间',
    SITE_DOWNLOAD_SITE: '导出站点信息',
    SITE_APPROVER: '审批人',
    SITE_APPROVAL_DESC: '请输入审批人',
    SITE_OWNER_SHIP: 'Client Ownership',
    SITE_SERVICE_GROUP: 'Engagement PC Sub-function',

    SITE_SEARCH_NAME_KEYWORD: '站点名称（关键字）',
    SITE_SEARCH_CLIENT_KEYWORD: '客户名称（关键字）',
    SITE_SEARCH_ENTITY: '实体数量',
    client_home: {
        kpTitle: '报表数据',
        clientTitle: '待办事项',
        workspace: '工作区',
        pbcItem: '待处理PBC条目',
        duePbcItem: '即将到期PBC条目',
        overduePbcItem: '已逾期PBC条目',
        revisionPbcItem: '需修订PBC条目',
        uploadPbcItem: '已上传PBC条目',
        confirmationItem: '待处理函证',
        stampingConfirmationItem: '待被审计单位授权',
        addressConfirmationItem: '被函证方已接收但尚未回函',
        mattersLogItem: '事项日志',
        solutionMattersLogItem: '未解决事项',
        clientContact: '联系信息',
        recommendTitle: '体验最佳KCC速度的建议',
        more: '更多',
        accountsOverview: '法定审计报告进度概览'
    },
    SITE_TABLE_HEADER_SITE_NAME: '站点名称',
    SITE_TABLE_HEADER_SITE_TYPE: '站点类型',
    SITE_TABLE_HEADER_SITE_ADMIN: '站点管理员',
    SITE_TABLE_HEADER_CREATE_BY: '创建人',
    SITE_TABLE_HEADER_CREATE_TIME: '创建时间',
    SITE_TABLE_HEADER_MODIFIED_TIME: '修改时间',
    recent_action_time: '最近操作时间',
    SITE_TABLE_HEADER_MODIFIED_BY: '修改人',
    SITE_TABLE_HEADER_IS_LLP: '毕马威华振项目',
    SITE_TABLE_HEADER_NUMBER_OF_ENTITIES: '实体/子公司数量',
    SITE_TABLE_HEADER_ENGAGEMENT_CODE: '项目编码',

    SITE_LABEL_SITE_OWNER: '项目合伙人',
    SITE_LABEL_SITE_MANGER: '项目经理',
    Site_NAME_INCORRECT_001: '导入文件中的“客户名称”须和此KCC站点的客户名称相同。',
    ENTITIES_ASSOCIATION_INCORRECT_001: '站点中已有的客户组织架构已经和角色、PBC清单或共享文件夹等进行了关联，无法再次批量导入。',
    ENTITY_IMPORT_010: '该KCC站点的“客户名称”和其他站点重名，请更改’客户名称‘后再尝试导入。',

    //Master Data Management
    MASTER_DATA_TITLE: '主数据管理',
    MASTER_DATA_PLACE_HOLDER: '事项',
    MASTER_DATA_TABLE_HEADER_ITEM_SUBJECT: '事项',
    MASTER_DATA_TABLE_HEADER_VALUE: '值',
    MASTER_DATA_ADD_KEY: '键',
    MASTER_DATA_ADD_VALUE: '值',

    PAGE_NEXTYEAR_POP_TITLE: '选择时间',
    PAGE_NEXTYEAR_ORG_TITLE: '客户组织结构',
    PAGE_NEXTYEAR_INSIGHT_TITLE: '毕马威高管研修',
    PAGE_NEXTYEAR_CLIENT_TITLE: '客户角色和用户',

    PAGE_PBCLIST_NAME: '资料清单名称',
    TABLE_HEADER_DETAILS: '详情',
    COMMON_VIEW: '查看',
    COMMON_COPY: '复制',
    COMMON_YES: '是',
    COMMON_NO: '否',

    AUDIT_TRAIL_TITLE: '访问足迹',
    AUDIT_TRAIL_TABLE_HEADER_ACCESS_URL: '访问 URL',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_IP: '操作 IP',
    AUDIT_TRAIL_TABLE_HEADER_USER_AGENT: '用户代理',
    AUDIT_TRAIL_TABLE_HEADER_USER_TYPE: '用户类型',
    AUDIT_TRAIL_TABLE_HEADER_OPERATOR: '用户名',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_LOG: '操作日志',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_TIME: '操作时间',

    GLOBAL_SWITCH_ENTITY: '按组成部分筛选',
    COMMON_PROJECT_NAME: '毕马威智联平台',
    NEW_COMMENT: '新增留言',
    INTERIM_AUDIT: '中期审计',
    OUTSTANDING: '待处理',
    REVISION: '需修订',
    UPLOADED: '已上传',
    ACCEPTED: '已接受',
    COMPLETED: '已完成',
    Overdue: '即将到期',
    DaysUntilDue: '已逾期',
    few_days_later: '几天后',
    Overdue_days: '逾期天数',

    ACCOUNT_STATUS_CREATE_AT: '创建于',
    ACCOUNT_STATUS_UPDATE_BY: '最后更新于',
    ACCOUNT_STATUS_SPREAD_BY: '操作人',
    ACCOUNT_STATUS_NOT_APPLICABLE: '不适用',
    ACCOUNT_STATUS_NOT_START: '未开始',
    ACCOUNT_STATUS_NOT_PROGRESS: '进行中',
    ACCOUNT_STATUS_NOT_COMPLETE: '已完成',
    FORM_VALIDATE_EMAIL: '请输入正确的邮箱地址',
    FORM_VALIDATE_IP: '请输入正确的IP地址',

    FILE_DELETE_005: '没有权限删除文件',
    PBC_GROUP_UPDATE_002: 'Pbc group name 已经存在',
    PBC_GROUP_COPY_001: '拷贝的资料清单名称在末期节点已存在，无法拷贝。',
    EXPORT_DATA_001: '导出失败！导出数据条目超过最大值5000，请通过筛选条件进行过滤。',
    FILE_DOWNLOAD_005: '下载文件的存储名称为空。',
    MASTER_DATA_QUERY_001: '主数据的值存在重复数据。',
    SAVE_ROLL_FOREARD_TASK_001: '该操作已经执行过，请勿重复提交。',
    MASTER_DATA_INVALID_002: '名称或值是空。',
    INSIGHT_003: '洞察标题不能为空。',
    MASTER_DATA_INVALID_003: '会计科目不能为空。',
    USER_DELETE_001: '当前用户无法删除自己。',
    TOPIC_EDIT_001: '该PBC科目中已有客户上传了文件，无法删除！',
    SITE_APPROVER_VALIDATION_001: '无效的站点审批人。',
    ROLL_FOREARD_TASK_TEXT1: '关闭当前站点后所有的PBC信息在',
    ROLL_FOREARD_TASK_TEXT2: '天后将被删除！',
    CLIENT_ROLE_ENTITY_OR_TILES: '实体或者板块不能为空！',
    PASSWORD_CHANGE_MESS: '您的密码快要到期了请修改密码！',
    PASSWORD_EXPIRED_MESS: '您的密码已过期，请修改密码！',
    CLIENT_ROLE_ENTITY: '请选择实体！',
    TOPIC_NAME_001: '会计科目重复！',
    USER_DELETE_002: '不能删除一个站点拥有者！',
    MASTER_DATA_INVALID_004: '键不能重复！',
    ENTITY_HAVECHILD_DELETE: '所属子实体删除后，才可删除该实体！',
    ENTITY_NODE_SELECT: '请先选择一个节点！',
    INSIGHTS_NO_DATA: '暂无数据',
    ENTER_MESSAGE_CONTENT: '请输入留言内容',
    placeholder_enter_email: '输入用户的工作邮箱',
    INSIGHT_MSG_TITLE: '配置毕马威高管研修!',
    CONFIG_FILE_LIMIT: '每个毕马威或客户用户的文件下载量超过以下设置的数值时，KCC将自动提醒站点管理员 （*数值均为0时，为无限制）',
    LIMIT_CYCLE: '周期',
    LIMIT_NUM: '数量',
    OR: '或',
    DOWNLOAD_AUTH: '允许客户用户之间相互下载彼此上传的文件？',
    EXCHANGE_TAB_CONTROL: '是否开启“集团审计”选项，以和各组成部分进行协作？ ',
    EXCHANGE_TAB_CONTROL_des: '打开此按钮后，则可以添加任意毕马威员工(包括毕马威香港/澳门/华振/海外成员所)访问此KCC站点。确认继续吗？',
    UNIT_01: '天',
    UNIT_02: '份',
    UNIT_03: '百分比',
    OPEN_LITE_AUTHORITY_WARNING: '打开此按钮，将使客户用户之间可以相互下载对方上传的文件。确认打开吗？',
    CLOSE_LITE_AUTHORITY_WARNING: '确认关闭此按钮吗？',
    COMMON_TIP: '提示',
    REVERSEAUTH_TIP: '一键应用此PBC条目至所有客户角色！',
    CANCLE_OPERATION: '已取消操作',
    CLIENT_ROLE_MSG:
        '请在创建好PBC清单和文件夹后再配置权限角色！如之后添加了新的PBC清单/PBC条目/文件夹类别，请相应更新至角色权限配置以刷新用户对新增内容的访问权限！',
    PBC_SELECT_STATUS: '请选择状态',
    PBC_SELECT_TOPS: '请选择会计科目（关键字）',
    PBC_TOPIC_DESC_TIP: '已识别的相关数据要素（关键字）',
    PBC_REVERSE_AUTH: '你确定在所有客户角色中勾选上这个PBC条目吗？\n（前提条件是：客户角色中此PBC条目所属的PBC清单已经被勾选上。）',
    PBC_DASHBOARD: 'PBC图表展现',
    PBC_INFO: 'PBC收集实时进度报表',
    FORM_VALIDATE_COMMENTS_MAX: '最多输入400个字!',
    NEW_COMMENTS_NULL: '请填写留言！',
    prompt_download: '下载中',
    loading:'加载中 ...',
    TERM_OF_USE_MUST_BE_AGREED: '请阅读并同意。',
    SITE_ADD_NEW_ITEM_LLP: '毕马威华振项目',
    SITE_ADD_NEW_ITEM_LLP_TIP: '此站点是否为毕马威华振项目而创建？',
    SITE_ADD_NEW_ITEM_OVERSEA: '此站点是否为毕马威香港/澳门项目而创建？',
    SITE_ADD_NEW_ITEM_KCC_SITE_TIP: '是否为KCC Lite站点?',
    CROSS_BORDER_CONTROL_POLICY: '此为毕马威华振项目站点。依据数据跨境政策要求，不允许毕马威香港或澳门员工访问。',
    CROSS_BORDER_CONTROL_TITLE: '不能添加该员工',
    USER_PROFIT_001: `数据跨境政策重要提示！<br>毕马威香港项目的KCC站点不可以添加毕马威华振或海外成员所的毕马威员工。<br>毕马威华振项目的KCC站点不可以添加毕马威香港/澳门或海外成员所的毕马威员工。<br>只有当毕马威香港或毕马威华振项目是集团审计组，需要从其他毕马威组成部分项目组收集报告资料时，则可以添加其他毕马威员工(包括毕马威香港/澳门/华振/海外成员所)访问KCC站点，但仅限访问“集团审计”版块。`,
    DOWNLOAD_FILE_NAME: '文件名',
    DOWNLOAD_SIZE: '文件大小',
    DOWNLOAD_BY: '最近下载人',
    FILE_DOWNLOAD_BY: '下载人',
    DOWNLOAD_TIME: '最近下载时间',
    UPLOAD_BY: '上传人',
    UPLOAD_TIME: '上传时间',
    HISTORY: '历史记录',
    VERSION_HISTORY: '历史版本',
    IMPORT_ENTITY_BUTTON: '导入客户组织结构',
    addEntityTips: '将鼠标指向实体将出现更多操作按钮！',
    entity_upload_info_title: '重要提醒！',
    entity_upload_info1: '重复导入的组织架构文件，将会覆盖和替换站点上已有的客户组织架构！',
    entity_upload_info2: '如果现有的客户组织结构已经和角色，PBC清单，或共享文件夹相关联，则无法再次批量导入!',
    FILE_NAME_LABEL: '文件名称',
    ENTITY_FILE_NAME_LABEL: '上传组织架构文件',
    ACCOUNT_FILE_NAME_LABEL: '上传定制化PBC条目文件',
    ERROR_DETAIL_LABEL: '错误详情',
    CLOSE_BUTTON: '关闭',
    FAQ_TITLE: '常见问题解答',
    KCC_portal_TITLE: 'KCC Portal',
    FAQ_HEADER_TITLE: 'KCC常见问题解答',
    FAQ_KCC_Q1: '什么是毕马威智联平台（KCC）？',
    FAQ_KCC_A1: `点击这个<a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">KCC简介视频</a>快速了解以下kcc各功能模块。`,
    FAQ_KCC_Q2: '如何登录KCC呢',
    FAQ_KCC_A2: `点击这里查看1分钟<a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">KCC登录演示视频。</a>`,
    FAQ_KCC_Q3: '如何通过KCC提交审计资料？',
    FAQ_KCC_A3: `点击这个<a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">提交审计资料短视频</a>查看通过视频演示。`,
    FAQ_KCC_Q4: '我还可以通过KCC获取什么信息？',
    FAQ_KCC_A4: `点击这个<a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">“KCC更多功能概览”</a>短视频快速了解。`,
    FAQ_SERIAL_TITLE1: 'KCC登录相关问题解答',
    FAQ_SERIAL1_Q1: `如何开始使用KCC？`,
    FAQ_SERIAL1_A1: `KCC是网页版平台。点击<a style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;" href={href} target="_blank">这里</a>进入KCC登录界面，使用您已经注册的工作邮箱，密码和发至您邮箱的验证码即可快速登录KCC。`,
    FAQ_SERIAL1_Q2: `KCC支持哪些浏览器？`,
    FAQ_SERIAL1_A2: `建议您使用Google Chrome, Microsoft Edge或微软IE 10/11及以上版本的浏览器，以确保最佳性能。`,
    FAQ_SERIAL1_Q3: `我没有收到KCC的初始密码，怎么办？`,
    FAQ_SERIAL1_A3: `请联系您的毕马威项目团队获取帮助！`,
    FAQ_SERIAL1_Q4: `我收不到登录KCC的验证码，怎么办？`,
    FAQ_SERIAL1_A4: `点击KCC登录界面的“联系我们”按钮获取帮助！`,
    FAQ_SERIAL1_Q5: `我可以使用移动设备收到登录KCC的验证码吗？`,
    FAQ_SERIAL1_A5: `不可以。登录KCC的验证码将发送至您注册的的工作邮箱。`,
    FAQ_SERIAL1_Q6: `短时间没操作，KCC便要求我重新登录。怎么办？`,
    FAQ_SERIAL1_A6: `打开KCC主页右上角的下拉框，点击“配置系统超时”，您可以将登录超时延长至最多8小时。`,
    FAQ_SERIAL1_Q7: `忘记了登录密码怎么办？`,
    FAQ_SERIAL1_A7: `您可以点击登录界面的“忘记密码？”按钮，轻松设置新密码。请注意，每天只可重置一次密码。`,
    FAQ_SERIAL1_Q8: `如何更改密码？`,
    FAQ_SERIAL1_A8: `您可以在KCC主页右上角的下拉列表中找到“更改密码”按钮。`,
    FAQ_SERIAL1_Q9: `我可以通过移动设备访问KCC吗？`,
    FAQ_SERIAL1_A9: `不可以。`,
    FAQ_SERIAL1_Q10: `KCC系统支持双语吗？`,
    FAQ_SERIAL1_A10: `是的，KCC支持中文和英文。点击KCC主页右上角下拉列表中的“切换语言”可一键切换。`,
    FAQ_SERIAL_TITLE2: '与文件相关问题解答',
    FAQ_SERIAL2_Q1: `KCC支持哪些文件类型？`,
    FAQ_SERIAL2_A1: `KCC支持以下文件类型: .xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.其他特殊文件类型，请将文件压缩为zip文件后再上传至KCC。`,
    FAQ_SERIAL2_Q2: `KCC上单个文件大小有限制吗？`,
    FAQ_SERIAL2_A2: `单个文件大小不超过1GB。`,
    FAQ_SERIAL2_Q3: `我可以在KCC上直接打开文件吗？`,
    FAQ_SERIAL2_A3: `不可以。你需要先将文件下载后再打开。`,
    FAQ_SERIAL2_Q4: `KCC会保留文件的历史版本吗？`,
    FAQ_SERIAL2_A4: `是的。打开文件列表，在每份文件的最右栏可以查看到历史版本记录。`,
    FAQ_SERIAL2_Q5: `在文件列表中，我如何区分毕马威团队或者我们上传的文件？`,
    FAQ_SERIAL2_A5: `毕马威团队上传的文件将用蓝色底色标出。`,
    FAQ_SERIAL2_Q6: `为什么我看到KCC上的文件名字是乱码？`,
    FAQ_SERIAL2_A6: `这可能是因为您的浏览器开启了自动翻译功能。请关闭自动翻译功能后再查看。`,
    FAQ_SERIAL_TITLE3: '其他常见问题',
    FAQ_SERIAL3_Q1: `关于KCC的问题或建议，我应该联系谁？`,
    FAQ_SERIAL3_A1: `点击KCC站点主页上方的“联系我们”按钮，您可提出遇到的任何问题或建议（也可上传附件），毕马威的KCC支持团队收到后将为您解答。`,
    FAQ_SERIAL3_Q2: `使用KCC的授权和访问权限是如何管理的？`,
    FAQ_SERIAL3_A2: `KCC的授权和访问权限由毕马威项目组管理。毕马威团队将根据您的角色和职责定制您对KCC的访问权限，例如实体/子实体，功能模块、审计资料需求列表等。`,
    FAQ_SERIAL3_Q3: `我们不同实体或者团队访问KCC的权限可以被隔离开吗？`,
    FAQ_SERIAL3_A3: `可以。客户权限配置支持多层极访问权限控制, 从实体到功能模块，再到PBC清单或共享文件夹，甚至PBC清单中的具体条目， 以灵活地满足客户多样化的访问权限要求，如按岗位或部门进行权限控制。`,
    FAQ_SERIAL3_Q4: `我有一些非审计资料（PBC）相关的文件需要和毕马威团队分享，如何操作呢?`,
    FAQ_SERIAL3_A4: `KCC“携手共享”版块使您可以和毕马威团队便捷地分享除审计资料提交外的其他文件。`,
    FAQ_SERIAL3_Q5: `有一些审计资料需求条目对我们不适用，如何操作呢？`,
    FAQ_SERIAL3_A5: `点击“信息来源”列，您可以将这些条目调整为“不适用”。`,
    FAQ_SERIAL3_Q6: `我可以通过KCC实时查看审计资料（PBC）提交的进度吗？`,
    FAQ_SERIAL3_A6: `可以。点击审计资料提交（PBC）界面右侧的PBC进度仪表盘<i class="el-icon-s-data" style="background-color: rgb(161, 114, 169);color: #ffffff;"></i>，您可以实时追踪已提交和未提交的审计资料条目。`,
    FAQ_SERIAL3_Q7: `为什么审计资料提交（PBC）进度仪表盘<i class="el-icon-s-data" style="background-color: rgb(161, 114, 169);color: #ffffff;"></i>的数据好像不完整?`,
    FAQ_SERIAL3_A7: `PBC进度仪表盘仅显示您有权限且正在查看的PBC条目。“清除筛选条件”即可查看您所有授权查看的PBC条目。`,
    FAQ_SERIAL3_Q8: `我如何和毕马威团队在线沟通发现的审计事项？`,
    FAQ_SERIAL3_A8: `将您的鼠标悬浮在审计事项状态，点击编辑按钮<i class="el-icon-edit" style="color: rgb(76, 161, 157);"></i>，即可就审计事项添加评论或上传相关资料。`,
    FAQ_SERIAL3_Q9: `我可以更新法定审计报告的进度状态吗？`,
    FAQ_SERIAL3_A9: `不可以。您拥有只读权限。`,
    FAQ_TABLE_TITLE1: '客户应提供的资料管理（PBC）',
    FAQ_TABLE_DES1: '高效收集审计资料,并实时透明化收集进度',
    FAQ_TABLE_TITLE2: '携手共享',
    FAQ_TABLE_DES2: '便捷安全地分享文件以及在线信息技术问卷调查',
    FAQ_TABLE_TITLE3: '法定审计报告状态',
    FAQ_TABLE_DES3: '实时透明化法定审计报告的进度状态',
    FAQ_TABLE_TITLE4: '事项日志',
    FAQ_TABLE_DES4: '及时沟通审计事项，以推动解决和避免日后误解',
    FAQ_TABLE_TITLE5: '毕马威高管研修',
    FAQ_TABLE_DES5: '企业的成长伙伴。有趣，有料，有故事。',
    TOPIC_TYPE: {
        _1: 'CP',
        _2: 'FS-银行',
        _3: 'FS-保险',
        _4: 'FS-租赁',
        _5: 'FS-证券',
        _6: 'FS-基金',
        _7: 'ITA'
    },
    PBC_LIST_TIPS: `*在你可以新建或访问已有的PBC清单前，请和KCC站点管理员（默认为项目经理）确认你已经被分配了合适的权限!`,
    JOINT_WORKING_ADD_TIPS: `*在你可以新建文件夹前，请和站点管理员（默认为项目经理）确认你已经被分配了合适的权限!`,

    max_speed_title: '体验最佳KCC速度的建议！',
    upload_file_valid: `系统正在逐一验证已上传的文件,请耐心等待所有文件验证成功至显示为<i class="el-icon-circle-check" style="color: #67C23A"></i> … (根据不同的文件大小这可能需要几秒或者几分钟的时间)`,
    upload_tip: `在所有文件上传完成且验证成功后<i class="el-icon-circle-check" style="color: #67C23A"></i> ,再关闭此窗口！`,
    page_tip: '(速度最佳!)',
    page: '页',
    upload_btn_show: '(选择需上传的文件后，点击下方的‘上传’按钮开始文件上传！)',
    pbc_batch_upload_tip: '批量配置当页条目',
    PBC_ACCEPT_CONFIRM_MSG: '调整为“已接受”后，该PBC条目将不可以再更新，也不可以上传更多文件（已有文件可继续下载）。确认继续吗？',
    FILE_DELETE_WARNING_MSG: '该文件及历史版本（如有）均会被删除，且不可恢复！确认删除吗？',
    FILE_DELETE_WARNING_MSG_ONLY: '该文件将被删除，且不可恢复！确认删除吗？',
    BEFORE_CLOSE_WARING_MSG: '文件上传正在进行中，关闭窗口将中断文件上传，请确认是否关闭?',
    COMMON_NOTIFY: '通知',
    pbc_notify_temp: `<div>“客户实体筛选按钮<i class="fa fa-sitemap" style="background: #7213ea;color: #fff; padding: 5px"></i> ”进行了优化！如你发现部分PBC条目未显示，请确认<i class="fa fa-sitemap" style="background: #7213ea;color: #fff; padding: 5px"></i> 中相关实体是否已经勾选上!</div>`,
    no_assign: '未分配',
    patch_set_role: '批量管理权限',
    onkeyUpdateClientRolesConfirm: '一键更新至所有client roles？',
    show_search_conditions: '显示筛选条件',
    hide_search_conditions: '隐藏筛选条件',
    select_all: '全选',
    unselect_all: '全不选',
    patch_delete: '批量删除条目',
    please_sent_initial_password: '部分客户用户还未收到登录KCC的初始密码!点击这个按钮给他们发送初始密码和KCC登录链接，以开始使用KCC！',
    i_know: '我知道了',
    pbc_email_notice: '此提醒邮件将同时抄送给你自己及所有站点管理员。',
    send_me_a_preview: '发给我自己预览',
    preview:'预览',
    please_select_visible_site: '请选择你想要显示或隐藏的项目站点卡片',
    please_select_visible_site_placeholder: '所有站点均被隐藏！请选择需要显示的站点。',
    create_date: '创建日期',
    Created_Date: '创建日期',
    last_role_delete:
        '删除所有角色权限后，客户将可能无法登录KCC，也无法访问“PBC/携手共享/法定审计报告/事项日志/毕马威高管研修”版块内容。确定删除所有角色吗？',
    patch_delete_user: '批量删除用户',
    patch_delete_client_user_forbid: '包含已启用的客户用户，不可删除！请关闭”启用“按钮后重试！ ',
    patch_methods: '批量操作',
    reminder_on_PBC_list_page:
        '如创建了新的PBC清单，或在已有PBC清单中添加了更多需求条目/勾选了更多适用的实体，请相应更新“客户角色”配置以刷新用户对新增内容的访问权限！',
    reminder_when_adding_new_joint_working_folder:
        '如创建了新的文件夹类别，或对已有文件夹类别勾选了更多适用的实体，请将其相应更新至“客户角色”及“毕马威角色“配置以刷新用户对新增文件夹的访问权限！',
    BATCH_export: '导出文件记录',
    Export_PBC_Items: '导出PBC条目',
    Export_exchange_Items: '导出条目',
    Export_fapiao_Items: '导出所有发票信息',
    Export_invoice_Items: '导出所有账单信息',
    send_client_user_placeholder: '请选择要发送的客户用户',
    USER_ACCOUNT_IN_FILE_NOT_IN_WHITELIST: '导入的客户邮箱后缀未在白名单中，请先“设置邮箱白名单”！',
    USER_NAME_IN_FILE_IS_BLANK: '客户用户名（user name）不能为空！请补充后再次导入。',
    USER_ACCOUNT_IN_FILE_IS_REDUPLICATIVE: '模板中有重复的客户邮箱地址！请检查确认后再次导入。',
    form_code_type: 'Code 类型',
    updatePbcGroup_topicDesc_overlength: '导入模板中，“已识别的相关数据要素”部分单元格内容过多！不可超过250个汉字 （或250个英文字母）！',
    site_code: 'Code 编号',
    site_type: 'Code 类型',
    site_status: 'Code已关闭？',
    team_member: '授权的毕马威团队成员数量',
    client_user: '邀请的客户用户数量',
    file_upload_number: '已上传文件份数',
    file_upload_size: '已上传文件大小',
    file_download_size: '有下载记录的文件大小',
    file_download_number: '有下载记录的文件份数/下载次数',
    general_site_code_info:
        '<span>Code 编号: {code}</span><span style="margin-left: 50px;">Code 类型：{code_type}</span><span style="margin-left: 50px;">Code已关闭？： {is_roll}</span>',
    site_code_type_long_master: 'Master engagement code',
    site_code_type_long_sub: 'Sub-engagement code ',
    site_code_type_long_opp: 'Opportunity code',
    site_code_type_long_bd: 'Business development code',
    roll_forward_notice_1:
        '！此 KCC 站点目前所关联的 IBS engagement code[{code}] 被关闭时，站点中所有已上传的文件和沟通信息均已被自动删除！如需复用此KCC站点中已搭建好的框架至本期审计项目，请提交 OAK ticket <a target="_blank" style="color: #3879eb; font-weight: 600; text-decoration: underline;" href="http://cnshaapp103.cn.kworld.kpmg.com/OAK/User/CreateTicketFromProfiles.aspx">‘KCC 站点搭建服务> Roll forward 上一审计期间的 KCC 站点框架至本期审计项目‘</a>,以将此 KCC 站点所关联的 Engagement Code 更新为本期审计项目IBS engagement code! 否则该站点将在 [{date}] 被自动删除！',
    roll_forward_notice_2:
        '！每个 KCC 站点均须关联 IBS engagement code(Master engagement code 或 Sub-engagement code)！待本期审计项目的 engagement code 在 IBS 中创建好后，请及时联系 <a target="_blank" style="color: #3879eb; font-weight: 600; text-decoration: underline;" href="mailto:CN-FM%20KPMG%20Collaboration%20Centre%20%3ccnfmkpmgclicbt@kpmg.com%3e">KCC团队</a> 将 {codeType}[{code}] 更新为 IBS Engagement code！',
    roll_forward_notice_3:
        '！此 KCC 站点所关联的 Engagement Code[{code}] 被关闭时(IBS 中状态为‘Closed’)，站点中所有已上传的文件和沟通信息（事项日志，留言等）均会被自动删除！如果需要，请及时下载！',
    aDashboard_title: 'PBC收集过程回顾性报表',
    table_columns_display_btn: '隐藏不必要列',
    file_upload_date: '文件上传时间',
    file_upload_start_date: '上传开始时间',
    file_upload_end_date: '上传结束时间',
    general_code_info_title: '此KCC站点所关联的IBS Engagement Code 信息',
    file_exist: '该记录已存在，请勿重复添加!',
    head_video_mask: '观看此短视频，以快速了解如何提交PBC资料！',
    column_forbid_hidden: '这一列不允许隐藏',
    CLIENT_STATACC_STATE: '该实体无法删除,因为它关联的法定报告状态不是初始状态',
    CLIENT_MATTER_ENTITY_BIND: '该实体无法删除,因为它已经关联了事项日志',
    CLIENT_ROLE_ENTITY_BIND: '该实体无法删除,因为它已经关联了角色',
    PBC_ENTITY_BIND: '该实体无法删除,因为它已经关联了pbc清单',
    CATEGORY_ENTITY_BIND: '该实体无法删除,因为它已经关联了携手共享',
    client_role_setting_guidance_A: '未检测到与勾选的客户实体相关的PBC清单。请创建好PBC清单后再配置客户角色，以实现有效授权！',
    client_role_setting_guidance_B: '请勾选PBC清单，以实现有效授权！',
    client_role_setting_guidance_C: '请勾选PBC清单中的具体条目，以实现有效授权！',
    client_role_setting_exchange_empty: '请勾选“携手共享“版块中的具体内容，以实现有效授权！',
    client_role_setting_admin_empty: '请勾选“客户项目管理“版块中的具体内容，以实现有效授权',
    SITE_OWNER_IS_EMPTY: '站点负责人不能为空',
    SITE_ADMIN_IS_EMPTY: '站点管理员不能为空',
    UNIT: '单位',
    table_header_label_code_type: 'Code 类型',
    RolledForward: 'Code 已关闭？',
    SiteInfoModifiedTime: '站点信息修改时间',
    outstanding_PBC_requests_count: '未完成提交的PBC条目',
    outstanding_PBC_requests_count_TIP: '状态=“已逾期”或“即将到期”或“需修订”',
    client_submitted_but_pending_KPMG_confirmation_PBC_requests_count: '已上传的PBC条目',
    client_submitted_but_pending_KPMG_confirmation_PBC_requests_count_tip: '状态=“已上传”',
    KPMG_accepted_PBC_requests: '已接受的PBC条目',
    KPMG_accepted_PBC_requests_tip: '状态=“已接受”',
    submitted_before_deadline_pbc_request: '截止日期前提交的PBC条目',
    submitted_before_deadline_pbc_request_tip: '客户最后的文件上传日期≤截止日期(*) <br/><em>*客户开始上传文件之前所设置的截止日期</em>',
    overdued_pbc_count: '逾期提交的PBC条目',
    overdued_pbc_count_tip: '客户最后的文件上传日期≤截止日期(*) <br/><em>*客户开始上传文件之前所设置的截止日期</em>',
    overdued_on_average: '平均逾期天数',
    revision_required_count: '修订次数',
    rsdashboard_level1: 'Level 1',
    rsdashboard_level2: 'Level 2',
    rsdashboard_level3: 'Level 3',
    pbc_items_total: 'PBC条目总数',
    pbcDashboardTooltip: 'PBC收集实时进度报表',
    pbcRsDashboardTooltip: 'PBC收集过程回顾性报表',
    Due_Date_can_not_edit: '客户开始上传资料后，截止日期不可再更改！',
    Filter_per_Entity: '按客户实体筛选',
    login_welcome_1: '欢迎登录',
    login_welcome_2: 'KCC！',
    login_read_and_agree: '',
    // kcc最佳体验建议------------------------start------------------------
    kcc_max_speed_kp_tip1: `使用<span style="color: #3879eb;">Microsoft Edge</span> 浏览器访问KCC站点。`,
    kcc_max_speed_kp_tip2: `单个文件不超过<span style="color: #3879eb;">500MB</span>。`,
    kcc_max_speed_kp_tip3: `批量下载文件大小不超过<span style="color: #3879eb;">500MB</span>。`,
    kcc_max_speed_kp_tip4: `如单个文件超过500MB，请<span style="color: #3879eb;">逐一</span>上传。`,
    kcc_max_speed_kp_tip5: `在“PBC”和“携手共享”版块，将当页显示条目数量设置为<span style="color: #3879eb;">10</span>。`,
    kcc_max_speed_kp_tip7: '上传和下载超大文件或大批量文件时，请：',
    kcc_max_speed_kp_tip7_1: `在<span style="color: #3879eb;">公司内</span>进行`,
    kcc_max_speed_kp_tip7_2: `在<span style="color: #3879eb;">正常办公时间之外</span>进行`,
    kcc_max_speed_kp_tip7_3: `使用<span style="color: #3879eb;">有线</span>链接`,
    kcc_max_speed_client_tip1: `使用<span style="color: #3879eb;">Microsoft Edge</span> 浏览器访问KCC站点。`,
    kcc_max_speed_client_tip2: `单个文件不超过<span style="color: #3879eb;">500MB</span>。`,
    kcc_max_speed_client_tip3: `如单个文件超过500MB，请<span style="color: #3879eb;">逐一</span>上传。`,
    kcc_max_speed_client_tip4: `在“PBC”和“携手共享”版块，将当页显示条目数量设置为<span style="color: #3879eb;">10</span>`,
    click_to_upload: '点击上传',
    // kcc最佳体验建议------------------------end------------------------

    // ----------------Confirmation---------------------------------------------
    confirmation_dashboard_title: '审计函证进度概览',
    confirmation_dashboard_query_entity: '被审计单位名称',
    confirmation_dashboard_query_type: '函证类型',
    confirmation_dashboard_chart1_title: '总体进度',
    confirmation_dashboard_chart2_title: '进度分析',
    confirmation_dashboard_chart2_des_part1: '银行函证授权所需平均天数：',
    confirmation_dashboard_chart2_des_part2: '非银行函证授权所需平均天数：',
    confirmation_dashboard_chart2_des_part3: '天',
    confirmation_dashboard_chart3_title: '待被审计单位授权的函证分析',
    confirmation_dashboard_chart3_title_part1: '等待签字盖章的天数>=',
    confirmation_dashboard_chart3_title_part2: '天',
    confirmation_dashboard_table_title: '各家被审计单位的函证进度',
    confirmation_status: {
        _1: '制作中函证',
        _2: '待被审计单位授权',
        _3: '已签字盖章并寄往毕马威<br /> (适用于纸质函证)',
        _3_3: '已签字盖章并寄往毕马威 (适用于纸质函证)',
        _4: '已发往被函证方',
        _5: '被函证方已接收但尚未回函',
        _6: '已收到回函'
    },
    status_operate_tip: `<span style="color: #fd349c">(请签字盖章)</span>`,
    confirmation_type: {
        _0: '非银行函证',
        _1_all: '银行函证',
        _1: '银行函证-纸质函',
        _2: '银行函证-电子函'
    },
    confirmationGuide: '函证业务操作指引',
    confirmationGuideTips: '请单击对应银行名称，下载并查看授权指引，完成线上授权。',
    total: '合计',
    minimum: '最小值',
    maximum: '最大值',
    show_confirmation_overview: '显示函证总体进度',
    hide_confirmation_overview: '隐藏函证总体进度',
    confirmation: {
        homepage: {
            tab: {
                dashboard: '统计图',
                details_list: '函证清单'
            }
        },
        details_list: {
            confirmationTip_kp:
                '请被审计单位负责人按照授权指引完成授权。如需了解更多，请点击观看<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">授权攻略视频。</a>如有操作问题，可观看<a style="color: #3879eb;font-weight:600" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mef2c9wg" target="_blank">KCC视频</a>或<a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/OAK%20documents/KPMG%20internal%20use%20Quick%20reference%20card%20-%20Use%20of%20KCC%20Audit%20Confirmation%20tile.CN.pdf" target="_blank">快速指引</a>。',
            confirmationTip_client:
                '请被审计单位负责人按照授权指引完成授权。如需了解更多，请点击观看<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">授权攻略视频。</a>如有操作问题，可观看<a style="color: #3879eb;font-weight:600" href="https://home.kpmg/cn/zh/home/insights/2022/08/the-audit-confirmation-tile-on-kcc.html" target="_blank">KCC视频</a>或<a style="color: #3879eb;font-weight:600" href="/confirmation_guide_cn.pdf" target="_blank">快速指引</a>。',
            confirmationTip_2: '点击查看审计函证进度概览，全面把控函证整体进度',
            zhizhi_kp: '- 纸质询证函：请按照<a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/Shared%20Documents/Hardcopy%20Audit%20Confirmations/%E5%AE%A1%E8%AE%A1%E7%94%A8%E8%AF%A2%E8%AF%81%E5%87%BD%E2%80%94%E2%80%94%E6%8E%88%E6%9D%83%E8%A6%81%E7%82%B9.pdf" target="_blank">《审计用询证函-授权要点》</a>的指引打印并完成授权盖章；',
            zhizhi_client: '- 纸质询证函：请按照<a style="color: #3879eb;font-weight:600" href="/confirmation_guide_authorization_essentials.pdf" target="_blank">《审计用询证函-授权要点》</a>的指引打印并完成授权盖章；',
            dianzi: '- 电子询证函：请点击下方函证清单中“被函证方名称”前的图标，查看<a style="color: #3879eb;font-weight:600" href="/#/confirmation-guide" target="_blank">授权指引</a>，完成线上授权。',
            videoTipKp: `<div style="color: #14263b;">1. 如需了解本模块（审计函证）的系统操作，请点击观看KCC 审计<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mef2c9wg">函证授权操作视频</a>或查看<a style="color: #3879eb; font-weight: 600;" target="_blank" href=" https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/OAK%20documents/KPMG%20internal%20use%20Quick%20reference%20card%20-%20Use%20of%20KCC%20Audit%20Confirmation%20tile.CN.pdf">操作指引</a>；2. 如需了解被审计单位签字盖章的注意事项，请点击观看<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">授权攻略视频</a>。</div>`,
            videoTipClient: `<div style="color: #14263b;">1. 如需了解本模块（审计函证）的系统操作，请点击观看KCC 审计<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://home.kpmg/cn/zh/home/insights/2022/08/the-audit-confirmation-tile-on-kcc.html">函证授权操作视频</a>或查看<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://assets.kpmg/content/dam/kpmg/cn/pdf/zh/2022/08/quick-reference-card.pdf">操作指引</a>；2. 如需了解被审计单位签字盖章的注意事项，请点击观看<a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">授权攻略视频</a>。</div>`,
            btns: {
                download_confirmation: '下载函证文档',
                print_confirmation: '批量打印函证',
                export_list: '导出函证清单',
                update_status: '批量标注寄回毕马威',
                clear: '清空筛选',
                reprint: '需再次盖章授权'
            },
            operate_tip: '勾选审计函证并点击操作以上按钮：',
            table: {
                unique_id: `函证ID`,
                unique_id_nocss: `函证ID`,
                confirmation_type: '函证类型',
                entity_name: '被审计单位名称',
                addressee_entity_name: '被函证方名称',
                balance_sheet_date: '资产负债表日',
                ticketNo: '订单编号',
                client_responsible_person: '被审计单位负责人',
                kpmg_responsible_person: '毕马威负责人',
                client_authorisation_status: '函证状态',
                confirmation_status: '详细函证状态<br/> <span style="color:#fd349c;">（仅KPMG员工可见）</span>',
                confirmation_status_no_br: '详细函证状态 <span style="color:#fd349c;">（仅KPMG员工可见）</span>',
                days_of_pending_for_authorisation: '待被审计单位授权的天数',
                confirmation_uploaded_time: '函证中心上传函证的时间',
                current_status_time: '函证状态的更新时间',
                courier_no: '被审计单位寄回函证的快递单号',
                input_comments: '备注',
                historical_comments: '历史记录',
                courier_no_2: '寄出给被函证方的快递单号',
                dateDeliveredToAddressee: '被函证方签收函证的时间',
                number_of_days_since_received: '被函证方已接收但尚未回函天数'
            },
            not_print: '未打印',
            updateStatusForm: {
                courier_no: '被审计单位寄回函证的快递单号'
            }
        }
    },
    confirmation_superuser_open_tip: '警告:该用户将被授权查看该客户下所有询证函, 您确认吗?',
    sync_from_IBS: 'IBS 自动同步',
    please_check_list_wanna_edit: '审计函证未被勾选',
    confirmation_print_oversize: '批量打印文件大小上限为 1GB，请重新选择',
    please_choose_status_or_input_Courier_no: '请选择状态或填写快递单号',
    please_input_Courier_no: '请填写快递单号',
    check_valid_data: '请选择有效数据',
    common_empty: '空',
    begin_date: '开始日期',
    end_date: '结束日期',
    kprole_entity_confirmation_tip: '（毕马威团队成员均可查看“审计函证”及“客户项目管理”版块中所有内容，和所分配角色中勾选的实体无关。）',
    kpuser_role_confirmaion_tip: '毕马威团队成员均可查看“审计函证”版块中所有内容，和所分配角色无关。',
    kpuser_partstaff_confirmaion_tip: '仅可查看“携手共享”版块中的集团审计部分。',
    serialNo: '序号#',
    serialNoPlaceholder: '如：5 或 5, 6, 7 或 5-12',
    courierNoErr: '快递单号为10-30位数字、字母、中划线',
    deprecatedTicketTip: `请注意：订单编号 {ticketList} 已停止在KCC上传和更新函证，请您切勿在KCC site输入该订单编号下函证的任何信息 (包括函证状态、快递单号或备注等)。如需查看函证或进行沟通，请联系毕马威负责人线下沟通。`,
    exchangeCategory: {
        _1: '询证函',
        _2: '报告',
        _3: '模板',
        _4: '分析',
        _5: '细节测试样本',
        _6: '集团审计指引',
        _7: '集团会计手册',
        _8: '具体指引',
        _9: '集团层面审计程序记录',
        _10: '交付物提交',
        _11: 'Guidelines',
        _12: 'Instructions'
    },
    fileNameKeyword: '文件名(关键字)',
    batchDeleteUserConfirm: '如果该用户目前正在打开和使用此KCC站点，请在删除用户后，提醒用户及时登出该KCC站点！',
    sas_status: '状态',
    sas_date_fix: '状态更新日期时间',
    sas_date_cust: '自定义日期时间',
    milestone_title: '里程碑名',
    target_datetime: '目标日期',
    confirmation_cannot_download_tip: '因数据跨境限制，该询证函无法预览/下载，请您联系毕马威负责人。',
    export_list: '导出清单',
    client_visable: '对客户可见',
    disabled: '不可用',
    genral_cos_please_config_switch: '请选择要打开或关闭的功能版块',
    genral_cos_please_config_tiles: '请进一步配置各功能版块',
    config_pbc_tile: '客户应提供的资料管理(PBC)',
    config_joint_title: '携手共享',
    config_group_audit_title: '集团审计',
    config_exchange_title: '携手共享',
    config_Statutory_milestone: '法定审计报告状态（里程碑）',
    config_insights_item: '毕马威高管研修',
    config_confirmation: '审计函证',
    general_tile_confirmation: '审计函证',
    table_column_lable_milestone: '里程碑',
    table_column_lable_deadline: '需要“目标日期”列？',
    table_placeholder_deadline: '设置日期',
    table_column_lable_remarks: '备注',
    table_column_lable_client_show: '该里程碑对客户可见？ ',
    table_column_lable_action: '操作',
    export_statutory_list: '导出法定审计报告条目',
    enable_interim_audit: '是否启用中期审计？',
    general_tiles_interim_audit_switch: '是否开启‘中期’选项？',
    general_tiles_vat_audit_switch: '是否开启‘增值税信息’选项？',
    allow_component_down_upload: '是否允许组成部分团队下载集团审计团队所上传的文件?',
    enable_ITU: '启用信息科技整体情况调研',
    add_milestone: '添加里程碑',
    rename_milestone: '重命名里程碑',
    dialog_title_warning: '警告',
    confirm_delete_milestone: '确认删除该里程碑？',
    please_input_milestone_name: '请输入里程碑名',
    milestone_file_visible_to_client: '对客户可见？',
    for_kpmg_only: '（仅毕马威可见）',
    sas_confirm_set_visible: '确定要将此文件设置为对客户用户可见吗？',
    sas_confirm_set_invisible: '确定要对客户用户隐藏此文件吗？',
    MILESTONE_CANNOT_UPDATE: '里程碑不能更新',
    sas_dashboard_title: '法定审计报告进度分析',
    each_milestone_completion_time_allocation: '各里程碑完成量&时间分布',
    each_milestone_progress_overview: '各里程碑进度概览',
    all_entities_progress_overview: '全部实体进度概览',
    sas_dashboard_examples_14: '不适用或已完成',
    sas_dashboard_examples_23: '未开始或进行中',
    milestone_completion_alert: '调整为“已完成”或“不适用”后，该里程碑进度状态将不可再更改！确定继续吗？',
    confirm_not_editble_2: '调整为“已提交给集团项目组”后，双方在此进度状态下将不可继续上传更多文件或删除已上传的文件。确定继续吗？',
    confirm_not_editble_4: '调整为“集团项目组已审阅”后，将不可再做任何改动。确定继续吗？',
    forbid_update_status: '不允许更新状态',
    Notify_Client_About_Report_Progress: '提醒客户报告进度',
    Notify_Client_About_Uploaded_Draft_Reports: '提醒客户报告草稿已上传',
    recevier: '客户收件人',
    ccer: '抄送毕马威人员',
    exchange_tab1_recevier: '组成部分成员收件人',
    exchange_tab1_ccer: '抄送人',
    clear_filter: '清除筛选条件',
    move_left: '向左移动',
    move_right: '向右移动',
    rename: '重命名',
    printed: '（已打印）',
    MILESTONE_DATA_INVALID_001: '里程碑数据异常',
    MILESTONE_DATA_INVALID_002: '里程碑数据异常',
    milestone_name_invalid: '里程碑名不合法',
    milestone_name_invalid_special_char: '保存失败！里程碑命名描述中不可包含这些特殊字符： / : * ? < > | ” “ " , ，',
    base_info_setting: '基础信息',
    ask_for_save: '当前页面有更新，是否需要保存？',
    fold: '收起',
    unfold: '展开',
    clientUserAddTitleTip: '*该用户邮箱帐号同时已被授权访问KCC站点：{sites}，在共享此帐号信息的同时可访问多个授权的KCC站点。',
    CANNOT_DELETE_LAST_FIRST_LEVEL_MILESTONE: '不允许删除最后一个一级里程碑',
    SECOND_LEVEL_MILESTONE_NAME_REPEAT: '二级里程碑不允许重名',
    First_LEVEL_MILESTONE_NAME_REPEAT: '一级里程碑不允许重名',
    none_of_level2_milestone: '二级里程碑不允许为空',
    please_choose_recevier: '请选择收件人！',
    milestone_title_tip: '如果里程碑已经在进行中（即:任何一家实体的该里程碑进度有进度更新或已上传文件） ，则不可再进行更改！',
    sas_title_tip:
        '如需更改或定制里程碑设置，请站点管理员至“一般设置>管理各功能版块”进行调整。点击可查看<a style="color: blue;" href="https://spo-global.kpmg.com/:b:/r/sites/cn-oi-svc-AUD/KCC/KCC%E2%80%9C%E6%B3%95%E5%AE%9A%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A%E7%8A%B6%E6%80%81%E2%80%9D%E6%A8%A1%E5%9D%97%E5%BF%AB%E9%80%9F%E6%8C%87%E5%BC%95.pdf" target="_blank" style="color: #3879eb; font-weight: 600;text-decoration: underline;">快速指引</a>。',
    milestone_cannot_update_tooltip: '前面的里程碑状态为“已完成”或“不适用”时，才可启动更新下一个里程碑！',
    sas_upload_tip: '毕马威项目组在“法定审计报告”版块上传的文件默认对客户不可见。如需调整为对客户可见，请打开“文件列表”在首列进行设置！',
    delete_file: '删除文件',
    sas_delete_file_text: '确认要删除这份文件吗？',
    none_of_update_data: '没有可以更新的数据',
    please_select_role: '请选择角色',
    file_upoloaded_by_kp: '毕马威团队',
    file_upoloaded_by_client: '客户',
    file_downloaded_by_kp: '毕马威团队',
    file_downloaded_by_client: '客户',
    businesshome_left_title_kcc_sites: 'KCC 站点',
    businesshome_left_title_kcc_tiles: 'KCC 模块',
    businesshome_left_title_files_uploaded_by: '文件上传者',
    businesshome_left_title_files_downloaded_by: '文件下载者',
    businesshome_left_title_upload_time: '上传时间',
    businesshome_left_title_download_time: '下载时间',
    businesshome_right_row1_title_1: '上传文件总数',
    businesshome_right_row1_title_2: '上传文件总大小',
    businesshome_right_row1_title_3: '下载文件总数',
    businesshome_right_row1_title_4: '下载文件总大小',
    businesshome_right_row1_title_5: '下载总次数',
    businesshome_right_row1_title_pcs: '份',
    businesshome_right_row1_title_times: '次',
    businesshome_right_table1_title: '下载概览',
    export_the_list: '导出列表',
    table_column_downloaded_by: '客户实体',
    table_column_total_number_of_files: '文件总数<br/>(按文件 ID 去重)',
    table_column_size_of_downloaded_files: '下载文件大小<br/>(按文件 ID 去重)',
    grand_total: '总计',
    alter_setting: '设置预警值',
    downloaded_date: '下载日期',
    export_downloaded_files_list: '导出列表',
    downloaded_files: '下载文件列表',
    kcc_tile: '版块',
    alert_engagement_manager: '客户用户两周内下载文件量超过以上设定值时则会邮件告知项目经理',
    email_address: '邮箱地址',
    size: '大小',
    detailed_download_records: '详细下载记录',
    please_input_valid_serino: '请输入有效的序号筛选条件',
    if_show_confirmation_reply_status: '是否展示函证的回函状态？',
    you_can_input_day_count_will_auto_refresh: '您可以在文本框内输入天数，图表数据将会自动更新。',
    echarts4_subtitle: '(<span style="color:#fd349c;">点击</span>条形图，自动从清单界面<span style="color:#fd349c;">筛选</span>相应函证)',
    please_input: '请输入',
    confirmation_bar4_inputtip_1: '待被审计单位授权大于或等于__天',
    confirmation_bar4_inputtip_2: '被函证方已接收但尚未回函大于或等于__天',
    confirmation_echart4_title: '长时间待处理的函证分析',
    confirmation_replyRate_analysis: '回函率分析',
    confirmation_replyRate_analysis_comment: '已收到回函数 / 已发出函证数',
    reprint_reason: {
        _1: '盖章重叠',
        _2: '盖章模糊',
        _3: '授权页未加盖授权章',
        _4: '未加盖骑缝章/骑缝章不完整',
        _5: '盖章章名与被审计单位名称不符',
        _6: '其它,请输入'
    },
    reprint_dialog_title: '需盖章授权',
    reprint_dialog_tip:
        '请<span style="color: #ff2121">勾选</span>或输入需被审计单位再次盖章授权函证的原因，并点击确认。<br/><span style="color: ff2121">！</span>系统将<span style="color: #ff2121">自动发送再次授权提示邮件</span>至被审计单位函证负责人，同时函证的“已打印”的标识将被清除。',

    reason: '原因',
    please_input_reason: '请输入原因',
    reprint_please_choose_reason: '请选择或填写原因',
    onlyNotElectronic: '只能勾选非电子函的条目',
    confirmation_count: '函证数量',
    KCC_short_introduction: 'KCC视频简介',
    settingHomeTipHtml:
        '点击观看<a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk" target="_blank">‘配置KCC站点’</a>的演示视频',
    settingHomeTipLink: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk',
    sendNotifyEmailTipHtml:
        '点击查看<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=11&zoom=100,0,0" target="_blank">操作指引</a>',
    sendNotifyEmailLink:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=11&zoom=100,0,0',
    downloadPBCTipHtmlKp:
        '点击观看<a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_hewfrpun" target="_blank">‘下载PBC’</a>的演示视频',
    downloadPBCTipHtmlClient:
        '点击观看<a style="color: blue;" href="javascript:void(0)" onclick="showClientVideo()">‘上传PBC’</a>的演示视频',
    downloadPBCTip_1: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_hewfrpun',
    downloadPBCTip_2: '',
    sas_tip_html:
        '点击查看<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E2%80%9C%E6%B3%95%E5%AE%9A%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A%E7%8A%B6%E6%80%81%E2%80%9D%E6%A8%A1%E5%9D%97%E5%BF%AB%E9%80%9F%E6%8C%87%E5%BC%95.pdf?cid=ce2d967a-d44c-4ec5-ab11-dd104345440a" target="_blank">操作指引</a>及<a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_4new9krf" target="_blank">演示视频</a>',
    sas_tip_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E2%80%9C%E6%B3%95%E5%AE%9A%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A%E7%8A%B6%E6%80%81%E2%80%9D%E6%A8%A1%E5%9D%97%E5%BF%AB%E9%80%9F%E6%8C%87%E5%BC%95.pdf?cid=ce2d967a-d44c-4ec5-ab11-dd104345440a',
    confirmation_title: '审计函证清单',
    pbc_rsdashboard_tip:
        '<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Forms/AllItems.aspx?id=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC%2F%E2%80%98PBC%E6%94%B6%E9%9B%86%E5%9B%9E%E9%A1%BE%E6%80%A7%E6%8A%A5%E8%A1%A8%E2%80%99%E6%8C%87%E5%BC%95%2Epdf&parent=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC" target="_blank">快速指引</a>',
    pbc_rsdashboard_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Forms/AllItems.aspx?id=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC%2F%E2%80%98PBC%E6%94%B6%E9%9B%86%E5%9B%9E%E9%A1%BE%E6%80%A7%E6%8A%A5%E8%A1%A8%E2%80%99%E6%8C%87%E5%BC%95%2Epdf&parent=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC',
    businesshome_tip:
        '点击查看<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=10&zoom=100,0,0" target="_blank">操作指引</a>',
    businesshome_tip_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=10&zoom=100,0,0',
    exchange_tip_kp:
        '点击查看<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=4&zoom=100,0,0" target="_blank">操作指引</a>',
    exchange_tip_link_kp:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%E4%BD%BF%E7%94%A8%E5%B0%8F%E8%B4%B4%E5%A3%AB%E5%8F%8A%E5%8A%9F%E8%83%BD%E4%B8%8A%E6%96%B0.pdf#page=4&zoom=100,0,0',

    ITU_tip:
        '点击查看<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20%27%E4%BF%A1%E6%81%AF%E7%A7%91%E6%8A%80%E6%95%B4%E4%BD%93%E6%83%85%E5%86%B5%E8%B0%83%E7%A0%94%27%20%E6%A8%A1%E5%9D%97%20-%20%E5%BF%AB%E9%80%9F%E6%8C%87%E5%BC%95.pdf" target="_blank">操作指引</a>',
    ITU_tip_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20%27%E4%BF%A1%E6%81%AF%E7%A7%91%E6%8A%80%E6%95%B4%E4%BD%93%E6%83%85%E5%86%B5%E8%B0%83%E7%A0%94%27%20%E6%A8%A1%E5%9D%97%20-%20%E5%BF%AB%E9%80%9F%E6%8C%87%E5%BC%95.pdf',
    split_file_tip:
        '如单份文件超过1GB，请参考指引（使用<a style="color: blue;" href="/winrar_cn.pdf" target="_blank">WinRAR</a>或使用<a style="color: blue;" href="winzip_cn.pdf" target="_blank">WinZIP</a>）将大文件分卷为较小文件后再上传。',
    split_file_tip_link: '/winrar_cn.pdf',
    ita_status_not_started: '未开始',
    ita_status_in_progress: '进行中',
    ita_status_icon_completed: '已完成',
    ita_btn_notify_client: '提醒客户完成问卷',
    ita_btn_archive_questionnaire: '导出问卷',
    pagination_all: '全部',
    ita_add_qa: '新建问卷',
    ita_table_header_section: '章节',
    ita_section: {
        _1: 'IT 组织',
        _2: 'IT 策略',
        _3: 'IT 程序',
        _4: 'IT 系统',
        _5: '网络',
        _6: '安全'
    },
    ita_table_header_status: '状态',
    ita_table_header_client_responsible: '客户方联系人',
    ita_table_header_period_date: '期末日期',
    ita_table_header_due_date: '截止日期',
    ita_table_header_last_update_by: '最后更新人',
    ita_table_header_last_update_time: '最后更新时间',
    ita_table_header_delete: '删除',
    freetable_add_more: '添加更多',
    freetable_input_placeholder: '请输入{key}',
    freetable_input_others_placeholder: '请输入其他{key}',
    freetable_select_placeholder: '请选择{key}',
    ita_choose_files: '选择文件...',
    ita_upload_tip:
        '最多可上传100份文件；每份文件不可超过100MB！支持以下文件类型：xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    ita_please_check_rows: '请勾选要批量修改的条目',
    site_delete_notice: '确定继续删除该KCC站点吗？<br/>项目编码：{code}<br/>站点名称：{siteName}<br/>客户名称：{clientName}',
    kpt_member_add_notice:
        '注意：如您添加的是其他毕马威海外成员所人员，请确认已经将该人员信息及其所在办公室的IP范围发送给KCC Team且完成了相关配置，该人员才可打开此KCC站点！',
    ita_unsave_answer_notice: '尚未保存，是否确定关闭？',
    client_role_enable_itu: '信息科技整体情况调研',
    itu_auto_saving: '自动保存中',
    itu_auto_saving_html: '正在自动保存ITU问卷信息',
    itu_delete_notice: '将要删除该实体下的全部问卷',
    itu_please_check_rows_export: '请勾选要导出的条目',
    itu_please_answer_all_question: '请回答完全部问卷',
    itu_please_check_rows_notice: '请勾选要提醒客户未完成的条目',
    itu_list_delete_forbid: '此状态下的问卷禁止删除',
    itu_list_delete_forbid_2: '该实体下有处于不允许删除的状态下的问卷',
    next: '下一步',
    gotIt: '我知道了',
    filterFunction: '筛选条件移到各表头了',
    guidanceTip: '点击灯泡位置即可查看KCC相关使用指引',
    KPMGExecutiveEducation: '（原“洞察信息”模块）客户的成长伙伴。有趣，有料，有故事！',
    fileTracking: '点击此处按钮可实时查看客户团队的文件下载记录',
    newFapiaoTip:'您可以在这里查看到项目账单和发票了！',
    ITUnderstanding: '新增“信息科技整体情况调研”模块，以在线结构化收集客户IT信息。',
    confirmationStatus: '新增询证函回函状态!',
    sourceType_matterLog: '事项日志',
    sourceType_confirmation: '审计函证',
    sourceType_jointWorking: '携手共享',
    sourceType_pbc: 'PBC',
    sourceType_statutory: '法定审计报告状态',
    new_tag: '新',
    total_downloaded_files: '下载文件总数',
    few_days_later_input_disallow: '天数输入不合法',
    itu_upload_limit: '最多上传100个文件',
    site_add_notice: '请在保存之前确保网站的合法实体是正确的，保存后就不能再修改了！',
    itu_entity_add_repeat: '重复添加实体：{entities}',
    confirmation_only_can_reprint_printed_rows: '只能勾选已打印的条目',
    client_download_title_1: '两周内下载文件量',
    client_download_title_2: '两周内下载文件量',
    itu_summary_lock: '当前问卷已经被{username}锁定，请过五分钟后再试！',
    kee_menu_1: '会计课程',
    kee_menu_2: '税务课程',
    kee_menu_3: '发展课程',
    kee_menu_4: '审计协作',
    kee_menu_5: '洞察咨讯',
    kee_menu_1_desc: '最全最新的会计类课程，年度更新一网打尽！',
    kee_menu_2_desc: '各地税务系列课程，助力及时了解税务动态，轻松通关各地税务。',
    kee_menu_3_desc: '各类热点课程，精准地把握行业脉动！',
    kee_menu_4_desc: '全力赋能提高和审计互动的效率！',
    kee_my: '收藏课程',
    kee_online_courses: '线上课程',
    kee_offline_courses: '线下活动',
    kee_duration: '课程时长',
    kee_free: '免费',
    kee_charge: '收费',
    kee_like: '收藏',
    kee_remove_like: '移除收藏',
    kee_viewed: '已有 {num} 人观看',
    kee_course_column: '课程目录',
    kee_duration_2: '时长',
    kee_WITHDRAW: '已下架',
    kee_completeness: '完成度(T+1)',
    kee_play: '播放',
    kee_offline_detail_disabled: '已下架的课程不能访问课程详情',
    kee_course_desc: '课程介绍',
    kee_price: '定价',
    kee_detail: '课程详情',
    recommendTitle: '推荐课程',
    startCourse: '开始',
    kee_discount: '优惠',
    scan_qr_for_register: '扫码报名',
    kee_kp_view_in_mp: '内部用户在毕马威内部培训系统里观看',
    confirmation_dashboard_filtered: '清单已筛选',
    confirmation_bubble_1: '筛选函证',
    confirmation_bubble_2: '一键全选',
    confirmation_bubble_3: '打印函证，签字盖章后寄往毕马威；<br/>标注函证已寄出',
    confirmation_bubble_4: '全程追踪函证状态',
    confirmation_bubble_5: '查看进度及长时间待处理函证',
    dashboard_bubble_1: '选择被审计单位或函证类型',
    dashboard_bubble_2: '点击条形图，自动从清单界面筛选相应函证',
    component_team_mgt: '组成部分团队管理',
    'businesshome_codestatus_Set-up': 'Set-up',
    'businesshome_codestatus_In-use': 'In-use',
    businesshome_codestatus_Created: 'Created',
    businesshome_codestatus_Closed: 'Code Closed',
    activeTimeType_1: '创建用户',
    activeTimeType_2: '发送初始密码',
    activeTimeType_3: '用户登录',
    activeTimeType_4: '手工激活帐号',
    client_list_user_name: '客户的用户名',
    client_list_client_email: '客户邮箱',
    datepicker_shortcut_recently_week: '最近两周',
    datepicker_shortcut_recently_month: '最近一个月',
    datepicker_shortcut_recently_3month: '最近三个月',
    datepicker_shortcut_recently_6month: '最近六个月',
    datepicker_shortcut_recently_year: '最近一年',
    date_filter_begin: '日期',
    date_filter_end: '日期',
    date_filter_middle: '~',
    faq_1: 'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/SitePages/KCCQAs-CN.aspx',
    faq_2: '/faq_cn.pdf',
    comming_soon: '敬请期待',
    kee_video_tip_1:
        '点击查看<a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mwqfynjx" target="_blank">演示视频</a>',
    kee_video_tip_2:
        '点击查看<a style="color: blue;" href="https://kpmg.com/cn/zh/home/insights/2023/09/kcc-new-features-business-deployment.html" target="_blank">演示视频</a>',
    kee_video_link_1: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mwqfynjx',
    kee_video_link_2: 'https://kpmg.com/cn/zh/home/insights/2023/09/kcc-new-features-business-deployment.html',
    kee_my_empty: '尚未收藏任何课程',
    kee_my_empty1: '尚未浏览任何课程',
    authorise:{
        title:'授权您的客户查看项目账单和电子发票等信息！',
        p1:'KCC的“客户项目管理”版块自动抓取和汇总项目账单、发票、客户付款状态，以及增值税信息！',
        step1:'进入“客户用户”界面',
        step2:'使用“访问权限类别”列对客户进行授权！',
        ok:'好的',
        okTips:'我现在授权。',
        no:'了解',
        noTips:'我将在项目开具账单后授权'

    },
    admin: {
        entityName: '客户名称',
        description: '描述',
        signingDate: '签署日期',
        contractType: '合同性质',
        contract: '合同',
        fee: '费用协议',
        vat: '增值税信息',
        entityNameEn: '客户名称(英文)',
        entityNameCn: '客户名称(中文)',
        entityId: '客户ID',
        fapiaoRegistrationNumber: '纳税人识别号 ',
        fapiaoAddress: '地址',
        fapiaoPhoneNumber: '电话号码',
        bankAccount: '银行账号',
        bankAccountHolder: '开户银行',
        enterTip: '请输入{name}',
        selTip: '请选择{name}',
        downloadTpl: '下载模板',
        invoices: '账单',
        invoice:'账单',
        issuanceDate: '账单日期',
        feeAmount: '不含税价',
        totalAmount: '含税总价 ',
        invoiceCurrency: '币种',
        invoiceNumber: '账单号',
        invoiceContactEmail: '账单联系邮箱',
        status: '付款状态',
        overdueDays: '逾期天数',
        feeNote: '账单',
        fapiao:'发票',
        fapiaoTips:'针对多张账单开具一张或多张发票。',
        fapiaoToEntity:'客户实体',
        fapiaoAmount:'发票含税金额(元)',
        fapiaoIssueDate:'开票日期',
        fapiaoType:'发票票种',
        fapiaoNumber:'数电票号码',
        fapiaoReferenceCode:'发票代码',
        fapiaoPdf:'发票（PDF）',
        fapiaoXml:'发票（XML）',
        "08":'增值税电专',
        "10":'增值税电普',
        "81":'数电票（增值税专用发票）',
        "82":'数电票（普通发票）',
        selectionTips:'请选择需下载的文档类型',
        bill:'账单',
        pdf:'PDF',
        xml:'XML',
        overdueDaysDes: '已逾期{t}天',
        overdueDaysFullDes: '逾期{t}天后完成付款',
        NA: '不适用',
        overdueDaysRange: '逾期天数范围',
        overdueDaysRangeError: '逾期天数开始日期大于结束日期',
        toProvided: '待提供',
        'System synchronisation': '系统自动抓取',
        'NOT PAID': '未付款',
        'FULLY PAID': '已付清',
        'PARTIALLY PAID': '部分已付款',
        CANCELLED: '已取消',
        'Engagement letter/Client contract': '业务约定书/业务合同',
        Proposal: '投标文件',
        'Statements of Work or Work Orders': '工作说明书',
        'Multi-firm engagement (KPMG China as an originating firm)': '成员所合作协议（中国所作为发起合作方）',
        'Multi-firm engagement (KPMG China as an participating firm)': '成员所合作协议（中国所作为被引入方）',
        'Local Implementation Agreement': '本地执行协议',
        'Non-disclosure Agreement': '保密协议',
        'Personal Non-disclosure Agreement / Individual Confidentiality Undertaking': '个人签署的保密协议',
        'Contract with 3rd party (e.g. subcontractor agreement, alliance agreement)': '与第三方签署的合同',
        'Simplified (abridged) Chinese engagement letter (for filing purposes in Mainland China)': '简单合同（给税务局的付款合同）',
        'Others (Please explain)': '其他',
        enterKeyword: '请输入关键字',
        settlementDate: '付清日期',
        dataDeadline:'数据截止日期：',
        invoiceTip1:'这里所展示的账单数据是基于截止前一个工作日的毕马威记录。',
        invoiceTip2:'账单结算可能需要几天时间进行匹配和处理，因此会使这里所展示的“付款状态“更新有所延迟。'
    },
    pdwComplexity:{
        important:"重要提醒:",
        tips:'自2024年8月15日起，毕马威中国加强了安全控制措施，以增强对您数据的保护。其中一项举措是要求<span class="important">密码长度至少为12个字符</span>以提高安全性。请提前更新您的密码，以避免出现任何访问问题。',
        ok:'好的',
        okTips:'我现在更改密码',
        noted:'了解 ',
        notedTips:'我稍后更改密码',
        topTips:'自2024年8月15日起，毕马威中国要求<span class="important">密码长度至少为12个字符</span>，以增强您的访问安全性！'
    },
    login:{
        step: "步骤",
        step1:"账号",
        step2:"密码",
        step3:"验证码",
        SMS:"手机短信",
        Email:"邮件",
        next:"登录",
        continue:"下一步",
        phone:"手机号",
        forgot:"请输入验证码",
        confirmPassword:"确认新密码",
        newPassword:"新密码",
        forgotAccount:"账号（邮箱）",
        emptyPhone:"请输入手机号",
        validatePhone:"手机号码格式不正确",
        emptyVerification:"请输入验证码！",
        china:"+86 中国内地",
        HongKong:"+852 中国香港",
        Macau:"+853 中国澳门",
        changePassword:"请输入新密码"
     },
     MEMBER_TABLE_HEADER_CLIENT_ENTITIES:"授权的组成部分",
    TABLE_HEADER_CLIENT_ENTITIES:"授权实体",
    CLIENT_TABLE_HEADER_CLIENT_ENTITIES:"授权实体或角色",
    TABLE_HEADER_Access_Level:"访问权限类别",
    CLIENT_TABLE_HEADER_Access_Level:"访问权限类别",
    TABLE_HEADER_Client_Entities:"授权实体",
    Batch_Access:"批量管理权限",
    TABLE_HEADER_KP_Access_Level_Tip:"特定实体<br>*用户始终可以查看“客户项目管理”、“审计函证”、“毕马威高管研修”<br>以及“集团审计-共享文件”版块中的所有内容！",
    CLIENT_TABLE_HEADER_Access_Level_Tip:'所有<br>*“集团审计”版块对客户不可见！<br><br>特定实体<br>*a) 用户可以查看“客户项目管理”及“毕马威高管研修”版块中所有内容，<br>以及“审计函证”版块中自己所负责的函证; b) “集团审计”版块对客户不可见！',
    TABLE_HEADER_Access_Level_Tip:"ALL<br> *the 'GroupReporting' tiles is always hidden to client <br><br> SPECIFIC(Entities)<br>*a)user can always access all centent in 'Client Admin'\,<br>'KEE'titles\,and his/her responsible confirmations in<br> 'Audit Confirmation'title; b)the 'Group Reporting'<br> title is always hidden to client.",
    tailored_tip:"确认使该客户用户始终可以访问所有客户实体及所有功能版块中的内容吗？",
    tailored_warning:"重要提示!",
    USER_WORKING_PHONE:"手机号码",
     SMS_PHONE_DUPLICATED:"验证码在60秒内不可重复发送！请稍候再试。",
     SMS_PHONE_ERROR:"短信发送失败！请确认手机号正确后重新获取验证码。",
     SMS_PHONE_FORMAT:"短信发送失败！请确认手机号正确后重新获取验证码。",
     SMS_ERROR:"短信平台异常！请联系您的毕马威项目组获取帮助。",
     SMS_PHONE_UNIQUE:"该手机号码已被其他账号绑定！",
     ALL_OPTION:"所有",
     SPECIFIC_OPTION:"特定实体",
     SPECIFIC_OPTION2:"特定组成部分",
     TAILORED_OPTION:"定制化权限",
     All_ENTITIES:"所有实体",
     All_COMPONENTS:"所有组成部分",
     SELECT_TYPE:"请选择实体",
     SELECT_ROLE_TYPE:"请选择角色",
     login_step1_tip:"账号是毕马威项目组为您注册KCC账号时所使用的您的工作邮箱",
     login_step2_tip:"初次登录，请输入已发送至您工作邮箱（账号）的初始密码",
     CLIENT_NOTICE:'客户用户的访问权限管理迁移到这里了！<br>步骤1：选择“访问权限类别”<br>步骤2：选择“授权实体或角色”<br>授权完成！',
     KP_NOTICE:'毕马威团队成员的访问权限管理迁移到这里了！<br>步骤1：选择“访问权限类别”<br>步骤2：步骤2：选择“授权实体”<br>授权完成！',
     COMPONENTS_NOTICE:'组成部分团队成员的访问权限管理迁移到这里了！<br>步骤1：选择“访问权限类别”<br>步骤2：选择“授权的组成部分”<br>授权完成！',
     MEMBER_TABLE_HEADER_KP_Access_Level_Tip:"*组成部分团队成员始终可以查看“集团审计-共享文件”中的内容。",
     ROLE_CHANGE_TIP:"您勾选授权了所有的客户实体，所以“访问权限类别”将被自动调整为“所有”。",
    groupDashboardTooltip: '集团审计进度报表',
    groupDashboardTooltipDrawer: '集团审计-报告收集进度报表',
    workbench: '工作台',
    clientDashboard: {
        regulatoryPolicy: '政策解读',
        tech_transformation: '科技转型',
        insights: '专业洞察',
        KEE: '毕马威高管研修'
    },
    FILE_UPLOAD_007: '上传失败！系统繁忙。请稍后重新上传！',
    kpmgFinanceOnline: '毕马威财税在线',
    qrcodeTips: '手机扫一扫获取更多课程',
    required: '必选',
}
